
export const assetListData = [
    {
        "id": 1,
        "com_cd": "CM001",
        "asset_cd": "DB01",
        "asset_nm": "ENURIDODB01",
        "asset_ip": "100.100.100.138",
        "asset_type": "DB",
        "asset_spec": "Oracle",
        "asset_ver": "Oracle 11g",
        "os_ver": "RHEL Server release 6.6",
        "service_nm": "에누리닷컴 오라클 서버 #1",
        "location_nm": "LG CNS (부산)",
        "manager_nm": "김영원",
        "supervisor_nm": "이주현",
        "confidential_score": 2,
        "integrity_score": 3,
        "availability_score": 3,
        "asset_grd": "가",
        "asset_rnk": 3,
        "mac_no": "",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 2,
        "com_cd": "CM001",
        "asset_cd": "US03",
        "asset_nm": "ip-10-0-11-160",
        "asset_ip": "10.0.11.160",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "프론트 서버(Linux)_02",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "박진우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "7",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 3,
        "com_cd": "CM001",
        "asset_cd": "US04",
        "asset_nm": "ip-10-0-10-69",
        "asset_ip": "10.0.10.69",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "API 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "6",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 4,
        "com_cd": "CM001",
        "asset_cd": "US05",
        "asset_nm": "ip-10-0-11-215",
        "asset_ip": "10.0.11.215",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "API 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "9",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 5,
        "com_cd": "CM001",
        "asset_cd": "US06",
        "asset_nm": "ip-10-0-10-248",
        "asset_ip": "10.0.10.248",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "지갑 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이은우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "4",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 6,
        "com_cd": "CM001",
        "asset_cd": "US07",
        "asset_nm": "ip-10-0-11-189",
        "asset_ip": "10.0.11.189",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "지갑 서버(Linux)_02",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이은우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "8",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 7,
        "com_cd": "CM001",
        "asset_cd": "US08",
        "asset_nm": "ip-10-0-10-193",
        "asset_ip": "10.0.10.193",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "블록 스캔 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "2",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 8,
        "com_cd": "CM001",
        "asset_cd": "US09",
        "asset_nm": "ip-10-0-11-50",
        "asset_ip": "10.0.11.50",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "블록 스캔 서버(Linux)_02",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "10",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 9,
        "com_cd": "CM001",
        "asset_cd": "US10",
        "asset_nm": "ip-10-0-10-35",
        "asset_ip": "10.0.10.35",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "Admin 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "5",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 10,
        "com_cd": "CM001",
        "asset_cd": "US11",
        "asset_nm": "ip-10-0-11-86",
        "asset_ip": "10.0.11.86",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "Admin 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "11",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 11,
        "com_cd": "CM001",
        "asset_cd": "US12",
        "asset_nm": "ip-10-0-10-11",
        "asset_ip": "10.0.10.11",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "DB접근 관리(Linux)",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이은우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "12",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 12,
        "com_cd": "CM001",
        "asset_cd": "US13",
        "asset_nm": "ip-10-0-10-24",
        "asset_ip": "10.0.10.24",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "취약점 탐지/예방(Linux)",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이은우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "13",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 13,
        "com_cd": "CM001",
        "asset_cd": "WE01",
        "asset_nm": "special40",
        "asset_ip": "14.129.111.67",
        "asset_type": "WE",
        "asset_spec": "NginX",
        "asset_ver": "NginX 1.13.8",
        "os_ver": "FreeBSD 11.1",
        "service_nm": "웹 운영 서버(국내 쇼핑몰)",
        "location_nm": "가산 IDC",
        "manager_nm": "메이크샵 담당자",
        "supervisor_nm": "메이크샵 관리자",
        "confidential_score": 3,
        "integrity_score": 3,
        "availability_score": 3,
        "asset_grd": "가",
        "asset_rnk": 3,
        "mac_no": "",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 14,
        "com_cd": "CM001",
        "asset_cd": "WS01",
        "asset_nm": "WIN-HVGR7HUR4GN",
        "asset_ip": "222.239.175.239",
        "asset_type": "WS",
        "asset_spec": "Windows",
        "asset_ver": "Windows Server 2012",
        "os_ver": "-",
        "service_nm": "쉐어박스 윈도우",
        "location_nm": "브로드밴드IDC",
        "manager_nm": "김종성",
        "supervisor_nm": "손혁",
        "confidential_score": 3,
        "integrity_score": 3,
        "availability_score": 3,
        "asset_grd": "가",
        "asset_rnk": 3,
        "mac_no": "",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 19,
        "com_cd": "JG001",
        "asset_cd": "US01",
        "asset_nm": "ip-10-0-0-259",
        "asset_ip": "10.0.0.250",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "-",
        "service_nm": "Bastion 서버(Linux)",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "1",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-22T09:34:28Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-22T09:34:28Z"
    },
    {
        "id": 20,
        "com_cd": "JG001",
        "asset_cd": "US02",
        "asset_nm": "ip-10-0-0-259",
        "asset_ip": "10.0.0.250",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "-",
        "service_nm": "Bastion 서버(Linux)",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "1",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-22T09:34:28Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-22T09:34:28Z"
    },
    {
        "id": 21,
        "com_cd": "IN001",
        "asset_cd": "US01",
        "asset_nm": "ip-10-0-0-259",
        "asset_ip": "10.0.0.250",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "-",
        "service_nm": "Bastion 서버(Linux)",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "1",
        "sys_reg_user": "admin",
        "sys_reg_date": "2023-01-22T10:07:05Z",
        "sys_mod_user": "admin",
        "sys_mod_date": "2023-01-22T10:07:05Z"
    },
    {
        "id": 22,
        "com_cd": "IN001",
        "asset_cd": "US02",
        "asset_nm": "ip-10-0-0-259",
        "asset_ip": "10.0.0.250",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "-",
        "service_nm": "Bastion 서버(Linux)",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "1",
        "sys_reg_user": "admin",
        "sys_reg_date": "2023-01-22T10:07:05Z",
        "sys_mod_user": "admin",
        "sys_mod_date": "2023-01-22T10:07:05Z"
    },
    {
        "id": 31,
        "com_cd": "CM001",
        "asset_cd": "DB01",
        "asset_nm": "ENURIDODB01",
        "asset_ip": "100.100.100.138",
        "asset_type": "DB",
        "asset_spec": "Oracle",
        "asset_ver": "Oracle 11g",
        "os_ver": "RHEL Server release 6.6",
        "service_nm": "에누리닷컴 오라클 서버 #1",
        "location_nm": "LG CNS (부산)",
        "manager_nm": "김영원",
        "supervisor_nm": "이주현",
        "confidential_score": 2,
        "integrity_score": 3,
        "availability_score": 3,
        "asset_grd": "가",
        "asset_rnk": 3,
        "mac_no": "",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 32,
        "com_cd": "CM001",
        "asset_cd": "US03",
        "asset_nm": "ip-10-0-11-160",
        "asset_ip": "10.0.11.160",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "프론트 서버(Linux)_02",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "박진우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "7",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 33,
        "com_cd": "CM001",
        "asset_cd": "US04",
        "asset_nm": "ip-10-0-10-69",
        "asset_ip": "10.0.10.69",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "API 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "6",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 34,
        "com_cd": "CM001",
        "asset_cd": "US05",
        "asset_nm": "ip-10-0-11-215",
        "asset_ip": "10.0.11.215",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "API 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "9",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 35,
        "com_cd": "CM001",
        "asset_cd": "US06",
        "asset_nm": "ip-10-0-10-248",
        "asset_ip": "10.0.10.248",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "지갑 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이은우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "4",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 36,
        "com_cd": "CM001",
        "asset_cd": "US07",
        "asset_nm": "ip-10-0-11-189",
        "asset_ip": "10.0.11.189",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "지갑 서버(Linux)_02",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이은우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "8",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 37,
        "com_cd": "CM001",
        "asset_cd": "US08",
        "asset_nm": "ip-10-0-10-193",
        "asset_ip": "10.0.10.193",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "블록 스캔 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "2",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 38,
        "com_cd": "CM001",
        "asset_cd": "US09",
        "asset_nm": "ip-10-0-11-50",
        "asset_ip": "10.0.11.50",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "블록 스캔 서버(Linux)_02",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "10",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 39,
        "com_cd": "CM001",
        "asset_cd": "US10",
        "asset_nm": "ip-10-0-10-35",
        "asset_ip": "10.0.10.35",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "Admin 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "5",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 40,
        "com_cd": "CM001",
        "asset_cd": "US11",
        "asset_nm": "ip-10-0-11-86",
        "asset_ip": "10.0.11.86",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "Admin 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "11",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 41,
        "com_cd": "CM001",
        "asset_cd": "US12",
        "asset_nm": "ip-10-0-10-11",
        "asset_ip": "10.0.10.11",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "DB접근 관리(Linux)",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이은우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "12",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
];


export const assetInfoData =  {
        "id": 1,
        "com_cd": "CM001",
        "asset_cd": "DB01",
        "asset_nm": "ENURIDODB01",
        "asset_ip": "100.100.100.138",
        "asset_type": "DB",
        "asset_spec": "Oracle",
        "asset_ver": "Oracle 11g",
        "os_ver": "RHEL Server release 6.6",
        "service_nm": "에누리닷컴 오라클 서버 #1",
        "location_nm": "LG CNS (부산)",
        "manager_nm": "김영원",
        "supervisor_nm": "이주현",
        "confidential_score": 2,
        "integrity_score": 3,
        "availability_score": 3,
        "asset_grd": "가",
        "asset_rnk": 3,
        "mac_no": "",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
};


export const analysisListData = [
    {
        "id": 1,
        "report_id": "CM001_DB_2023_0004",
        "com_cd": "CM001",
        "asset_type": "DB",
        "report_nm": "템플릿 2023년도 DB",
        "report_desc": "템플릿",
        "created_ymd": "2023.01.20",
        "updated_ymd": "2023.01.30",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-07T00:00:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-07T00:00:00Z"
    },
    {
        "id": 2,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_type": "US",
        "report_nm": "템플릿 2023년도 서버(Linux)",
        "report_desc": "템플릿",
        "created_ymd": "2023.01.20",
        "updated_ymd": "2023.01.30",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-07T00:00:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-07T00:00:00Z"
    },
    {
        "id": 3,
        "report_id": "CM001_WE_2023_0003",
        "com_cd": "CM001",
        "asset_type": "WE",
        "report_nm": "템플릿 2023년도 WEB",
        "report_desc": "템플릿",
        "created_ymd": "",
        "updated_ymd": "",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-07T00:00:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-07T00:00:00Z"
    },
    {
        "id": 4,
        "report_id": "CM001_WS_2023_0002",
        "com_cd": "CM001",
        "asset_type": "WS",
        "report_nm": "템플릿 2023년도 서버(Windows)",
        "report_desc": "템플릿",
        "created_ymd": "",
        "updated_ymd": "",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-07T00:00:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-07T00:00:00Z"
    }
]


export const VAassetListData = [
    {
        "id": 1,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "DB01",
        "asset_nm": "ENURIDODB01",
        "asset_ip": "100.100.100.138",
        "asset_type": "DB",
        "asset_spec": "Oracle",
        "asset_ver": "Oracle 11g",
        "os_ver": "RHEL Server release 6.6",
        "service_nm": "에누리닷컴 오라클 서버 #1",
        "location_nm": "LG CNS (부산)",
        "manager_nm": "김영원",
        "supervisor_nm": "이주현",
        "confidential_score": 2,
        "integrity_score": 3,
        "availability_score": 3,
        "asset_grd": "가",
        "asset_rnk": 3,
        "mac_no": "",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 2,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "US03",
        "asset_nm": "ip-10-0-11-160",
        "asset_ip": "10.0.11.160",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "프론트 서버(Linux)_02",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "박진우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "7",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 3,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "US04",
        "asset_nm": "ip-10-0-10-69",
        "asset_ip": "10.0.10.69",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "API 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "6",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 4,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "US05",
        "asset_nm": "ip-10-0-11-215",
        "asset_ip": "10.0.11.215",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "API 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "9",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 5,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "US06",
        "asset_nm": "ip-10-0-10-248",
        "asset_ip": "10.0.10.248",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "지갑 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이은우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "4",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 6,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "US07",
        "asset_nm": "ip-10-0-11-189",
        "asset_ip": "10.0.11.189",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "지갑 서버(Linux)_02",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이은우",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "8",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 7,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "US08",
        "asset_nm": "ip-10-0-10-193",
        "asset_ip": "10.0.10.193",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "블록 스캔 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "2",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 8,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "US09",
        "asset_nm": "ip-10-0-11-50",
        "asset_ip": "10.0.11.50",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "블록 스캔 서버(Linux)_02",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "10",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 9,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "US10",
        "asset_nm": "ip-10-0-10-35",
        "asset_ip": "10.0.10.35",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "Admin 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "5",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
    {
        "id": 10,
        "report_id": "CM001_US_2023_0001",
        "com_cd": "CM001",
        "asset_cd": "US11",
        "asset_nm": "ip-10-0-11-86",
        "asset_ip": "10.0.11.86",
        "asset_type": "US",
        "asset_spec": "LINUX",
        "asset_ver": "Ubuntu 20.04.1",
        "os_ver": "",
        "service_nm": "Admin 서버(Linux)_01",
        "location_nm": "AWS Seoul Region",
        "manager_nm": "이재원",
        "supervisor_nm": "이은우",
        "confidential_score": 2,
        "integrity_score": 2,
        "availability_score": 2,
        "asset_grd": "나",
        "asset_rnk": 2,
        "mac_no": "11",
        "sys_reg_user": "",
        "sys_reg_date": "2023-01-04T07:06:00Z",
        "sys_mod_user": "",
        "sys_mod_date": "2023-01-04T07:06:00Z"
    },
];


export const measureListData = [
    {
        "id": 1,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-01",
        "measure_type": "LX1",
        "measure_nm": "root 이외에 UID/GID가 0인 사용자 존재여부",
        "important_grd": "M",
        "risk_cd": "R-LX1-01",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-06",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 2,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-02",
        "measure_type": "LX1",
        "measure_nm": "불필요한 계정 제거",
        "important_grd": "M",
        "risk_cd": "R-LX1-02",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-08",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 3,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-03",
        "measure_type": "LX1",
        "measure_nm": "불필요하게 쉘(shell)이 부여된 계정 존재여부",
        "important_grd": "M",
        "risk_cd": "R-LX1-03",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-07",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 4,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-04",
        "measure_type": "LX1",
        "measure_nm": "패스워드 정책 설정",
        "important_grd": "M",
        "risk_cd": "R-LX1-04",
        "cost_score": 5,
        "risk_score": 4,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-06",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 5,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-05",
        "measure_type": "LX1",
        "measure_nm": "일반 사용자의 SU 명령 제한",
        "important_grd": "M",
        "risk_cd": "R-LX1-05",
        "cost_score": 5,
        "risk_score": 4,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-07",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 6,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-06",
        "measure_type": "LX1",
        "measure_nm": "취약한 패스워드 사용 여부",
        "important_grd": "H",
        "risk_cd": "R-LX1-06",
        "cost_score": 5,
        "risk_score": 5,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-06",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 7,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-01",
        "measure_type": "LX2",
        "measure_nm": "계정 관련 파일 접근권한 설정",
        "important_grd": "H",
        "risk_cd": "R-LX2-01",
        "cost_score": 5,
        "risk_score": 4,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-12",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 8,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-02",
        "measure_type": "LX2",
        "measure_nm": "주요 디렉터리 접근권한 설정",
        "important_grd": "H",
        "risk_cd": "R-LX2-02",
        "cost_score": 5,
        "risk_score": 4,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-12",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 9,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-03",
        "measure_type": "LX2",
        "measure_nm": "네트워크 서비스 설정 파일 접근권한 설정",
        "important_grd": "M",
        "risk_cd": "R-LX2-03",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-12",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 10,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-04",
        "measure_type": "LX2",
        "measure_nm": "원격에서 root로 로그인 가능하지 않게 설정",
        "important_grd": "M",
        "risk_cd": "R-LX2-04",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-12",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 11,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-05",
        "measure_type": "LX2",
        "measure_nm": "R 서비스 설정파일 접근권한 설정",
        "important_grd": "M",
        "risk_cd": "R-LX2-05",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-12",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 12,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-06",
        "measure_type": "LX2",
        "measure_nm": "syslog.conf 파일 접근권한 설정",
        "important_grd": "M",
        "risk_cd": "R-LX2-06",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-12",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 13,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-07",
        "measure_type": "LX2",
        "measure_nm": "로그파일 접근권한 설정",
        "important_grd": "M",
        "risk_cd": "R-LX2-07",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-12",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 14,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-01",
        "measure_type": "LX3",
        "measure_nm": "UMASK 설정",
        "important_grd": "L",
        "risk_cd": "R-LX3-01",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-07",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 15,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-02",
        "measure_type": "LX3",
        "measure_nm": "PATH 설정",
        "important_grd": "M",
        "risk_cd": "R-LX3-02",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-07",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 16,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-01",
        "measure_type": "LX4",
        "measure_nm": "서비스 배너에 시스템 정보 제공 여부",
        "important_grd": "L",
        "risk_cd": "R-LX4-01",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-07",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 17,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-02",
        "measure_type": "LX4",
        "measure_nm": "불필요한 RPC 서비스 중지",
        "important_grd": "M",
        "risk_cd": "R-LX4-02",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-08",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 18,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-03",
        "measure_type": "LX4",
        "measure_nm": "불필요한 R 서비스(1) 구동 중지",
        "important_grd": "M",
        "risk_cd": "R-LX4-03",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-08",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 19,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-04",
        "measure_type": "LX4",
        "measure_nm": "불필요한 R 서비스(2) 신뢰관계설정",
        "important_grd": "M",
        "risk_cd": "R-LX4-04",
        "cost_score": 5,
        "risk_score": 3,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-08",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 20,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-05",
        "measure_type": "LX4",
        "measure_nm": "익명 FTP(Anonymous FTP) 사용 여부",
        "important_grd": "L",
        "risk_cd": "R-LX4-05",
        "cost_score": 5,
        "risk_score": 4,
        "difficulty_score": 5,
        "apply_time": "단기",
        "apply_action": "위험감소",
        "threat_cd": "TT-07",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    }
]
   
export const suggestListData = [
    {
        "id": 1,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-01",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n1. root 계정 외 UID가 0인 계정 존재 시 중복되지 않은 다른 UID로 변경\n2. 불필요한 계정이면 삭제\n3. 현재 계정이 사용중이면 명령어로 조치가 안되므로 /etc/passwd 파일을 수정하여 조치",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 2,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-02",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 3,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-03",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n로그인이 불필요한 시스템 계정 또는 휴먼 계정은 /usr/bin/nologin(/bin/false, /bin/nologin) 쉘을 부여",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 4,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-04",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n1. 새로 생성할 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/login.conf\ndefault:\\\n………………….\n:minpasswordlen=9:\\\n\n2. 새로 생성할 계정에게 적용 - 패스워드 최대 사용기간\ndefault:\\\n………………….\n:passwordtime=90d:\\\n\n3. 기존 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/pam.d/passwd\npassword requisite pam_passwdqc.so min=disabled,10,8,8,8\n\n4. 기존 계정에게 적용 - 패스워드 최대 사용기간\n# pw usermod -p 90d 계정명",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 5,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-05",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\nsu 권한을 특정 그룹에 존재하는 사용자만 사용하도록 다음중 한가지를 선택해서 사용\n\n1. wheel 그룹 및 su 파일 권한\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /usr/bin/su의 그룹을 wheel, 권한을 4750 변경\n\n2. PAM 모듈\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /etc/pam.d/su 파일의 내용을 auth requisite pam_group.so no_warn group=wheel\n - /usr/bin/su의 그룹을 wheel 변경\n - 참고 : PAM은 일반 사용자에게 적용 받는 모듈임",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 6,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-06",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n패스워드를 영문, 숫자, 특수 문자 3가지 조합 8자리 이상 또는 2가지 조합 10자리 이상으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 7,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-01",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n1. /etc/passwd 파일의 권한을 644 이하로 설정\n2. /etc/master.passwd 파일의 권한을 400으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 8,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-02",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n주요 디렉토리(/sbin, /etc, /bin, /usr/bin, /usr/sbin, /usr/lbin)에 타사용자의 쓰기 권한 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 9,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-03",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n네트워크 설정 파일(/etc/hosts, /etc/services, /etc/inetd.conf)에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 10,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-04",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n/etc/pam.d/login 설정 파일에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 11,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-05",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv, .rhosts 파일의 권한을 600 또는 400으로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 12,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-06",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf 파일에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 13,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-07",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n주요 로그 파일(/var/log/wtmp* /var/log/utmp* /var/log/auth.log /var/log/messages /var/log/lastlog /var/log/security)에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 14,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-01",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n/etc/profile에 umask 값을 022로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 15,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-02",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\nPATH 환경변수 현재 디렉토리를 의미하는 \".\"\" \"\"::\"\"를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 16,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-01",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n원격접근 시 서비스의 상세버전이 노출되지 않도록 제거하거나, 별도의 경고문구를 추가\n\n1. /etc/motd\n로컬 및 원격에서 로그인 성공 후 보여줄 메시지 파일로 이 파일에 로그인 시도 시 메시지를 추가\n\n2. telnet (/etc/inetd.conf)\n- /etc/inetd.conf 파일을 열어 ?h 옵션을 추가 (배너 정보 삭제)\ntelnet stream tcp nowait root /usr/libexec/telnetd telnetd -h\n\n- /etc/gettytab 파일을 열어 cb/ce/ck 행의 주석을 제거하고, 다음과 같이 설정\ndefault:\\\n:cb:ce:ck:lc:fd#1000:im=\\r\\n\\Hello.  Welcome to the box.\\r\\n\\r\\n:sp#1200:\n\n- /etc/issue.net 파일을 열어 로그인 시도 시 메시지를 추가\n\n3. ftp (/etc/inetd.conf)\n/etc/inetd.conf 파일을 열어 ?h 옵션을 추가\nftp stream tcp nowait root /usr/libexec/ftpd ftpd -l -h\n\n4. vsftpd\nvsftpd 설정 파일의 ftpd_banner 지시자의 주석을 제거하고 로그인 시도 시 메시지를 추가\n\n5. proftp\nproftp 설정 파일의 배너를 다음과 같이 설정\nServerName \"FTP Server\"\"",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 17,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-02",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n불필요한 RPC 서비스를 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 18,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-03",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n불필요한 r 서비스(rsh, rlogin, rexec)를 중지하고, 필요하지 않다면 해당 서비스를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 19,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-04",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv 파일에서 특정 호스트한 허용하도록 설정\n\nweb test : web 호스트의 test 사용자만 허용",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 20,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-05",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n1. ftp (/etc/inetd.conf)\n/etc/inetd.conf 파일을 열어 ?A 옵션을 삭제\n\n1. vsftpd\nvsftpd 설정 파일에서 anonymous_enable=NO로 설정\n\n3. proftp\n- proftp 설정 파일에서 Anonymous 섹션을 전체 삭제\n- proftp 설정 파일에서 Anonymous 섹션이 존재할 경우 해당 섹션 내의 User로 설정된 계정을 userdel 명령어로 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 21,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-06",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n1. /etc/pam.d/login 파일에서 account requisite pam_securetty.so 라인의 주석을 제거\n2. /etc/securetty 파일의 pts/1, pts/2 .. 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 22,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-07",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n1. SNMP 서비스를 사용하지 않으면 중지\n2. SNMP 서비스 사용 시 SNMP 설정 파일에서 다음과 같이 설정\n - com2sec noConfigUser default <변경값>",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 23,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-08",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n불필요한 서비스가 동작하고 있는지 확인 후 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 24,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-01",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf에서 인증과 관련된 서비스를 별도의 파일로 기록하도록 설정\n - auth.notice /var/adm/sulog",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 25,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-02",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf에 각 서비스별 로그를 기록하도록 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 26,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX6-01",
        "asset_spec": "freebsd",
        "suggest_desc": "■ 권고사항\n최신보안 패치 및 벤더 권장버전을 적용하고 정기적으로 점검",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 27,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-01",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n1. root 계정 외 UID가 0인 계정 존재 시 중복되지 않은 다른 UID로 변경\n2. 불필요한 계정이면 삭제\n3. 현재 계정이 사용중이면 명령어로 조치가 안되므로 /etc/passwd 파일을 수정하여 조치",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 28,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-02",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 29,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-03",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n로그인이 불필요한 시스템 계정 또는 휴먼 계정은 /bin/false, /bin/nologin, /sbin/nologin 쉘을 부여",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 30,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-04",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n1. 새로 생성할 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/login.defs\nPASS_MIN_LEN 8\n\n2. 새로 생성할 계정에게 적용 - 패스워드 최대 사용기간\n# vi /etc/login.defs\nPASS_MAX_DAYS 90\n\n3. 기존 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/pam.d/system-auth (password-auth도 적용)\npassword    requisite     pam_cracklib.so try_first_pass retry=3 minlen=8\n\n# vi /etc/security/pwquality.conf (7 버전 이상)\nminlen = 8\n\n4. 기존 계정에게 적용 - 패스워드 최대 사용기간\n# chage -M 90 계정명",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 31,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-05",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\nsu 권한을 특정 그룹에 존재하는 사용자만 사용하도록 다음중 한가지를 선택해서 사용\n\n1. wheel 그룹 및 su 파일 권한\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /usr/bin/su의 그룹을 wheel, 권한을 4750 변경\n\n2. PAM 모듈\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /etc/pam.d/su 파일의 내용을 auth requisite pam_group.so no_warn group=wheel\n - /usr/bin/su의 그룹을 wheel 변경\n - 참고 : PAM은 일반 사용자에게 적용 받는 모듈임",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 32,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-06",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n패스워드를 영문, 숫자, 특수 문자 3가지 조합 8자리 이상 또는 2가지 조합 10자리 이상으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 33,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-01",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n1. /etc/passwd 파일의 권한을 644 이하로 설정\n2. /etc/shadow 파일의 권한을 400으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 34,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-02",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n주요 디렉토리(/sbin, /etc, /bin, /usr/bin, /usr/sbin, /usr/lbin)에 타사용자의 쓰기 권한 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 35,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-03",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n네트워크 설정 파일(/etc/hosts, /etc/services, /etc/inetd.conf, /etc/xinetd.conf)에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 36,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-04",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n/etc/pam.d/login 설정 파일에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 37,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-05",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv, .rhosts 파일의 권한을 600 또는 400으로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 38,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-06",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf(/etc/rsyslog.conf) 파일에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 39,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-07",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n주요 로그 파일(/var/log/wtmp* /var/log/utmp* /var/log/auth.log /var/log/messages /var/log/lastlog /var/log/security)에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 40,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-01",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n/etc/profile에 umask 값을 022로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 41,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-02",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\nPATH 환경변수 현재 디렉토리를 의미하는 \".\"\" \"\"::\"\"를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 42,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-01",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n원격접근 시 서비스의 상세버전이 노출되지 않도록 제거하거나, 별도의 경고문구를 추가\n\n1. /etc/motd\n로컬 및 원격에서 로그인 성공 후 보여줄 메시지 파일로 이 파일에 로그인 시도 시 메시지를 추가\n\n2. telnet \n원격에서 접속 시도 시 보여줄 메시지 파일(/etc/issue.net)로 이 파일에 로그인 시도 시 메시지를 추가\n\n3. vsftpd\nvsftpd 설정 파일의 ftpd_banner 지시자의 주석을 제거하고 로그인 시도 시 메시지를 추가\n\n4. proftp\nproftp 설정 파일의 배너를 다음과 같이 설정\nServerName \"FTP Server\"\"",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 43,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-02",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n불필요한 RPC 서비스를 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 44,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-03",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n불필요한 r 서비스(rsh, rlogin, rexec)를 중지하고, 필요하지 않다면 해당 서비스를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 45,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-04",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv 파일에서 특정 호스트한 허용하도록 설정\n\nweb test : web 호스트의 test 사용자만 허용",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 46,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-05",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n1. vsftpd\nvsftpd 설정 파일에서 anonymous_enable=NO로 설정\n\n2. proftp\n- proftp 설정 파일에서 Anonymous 섹션을 전체 삭제\n- proftp 설정 파일에서 Anonymous 섹션이 존재할 경우 해당 섹션 내의 User로 설정된 계정을 userdel 명령어로 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 47,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-06",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n1. /etc/pam.d/login 파일에서 account requisite pam_securetty.so 라인의 주석을 제거\n2. /etc/securetty 파일의 pts/1, pts/2 .. 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 48,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-07",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n1. SNMP 서비스를 사용하지 않으면 중지\n2. SNMP 서비스 사용 시 SNMP 설정 파일에서 다음과 같이 설정\n - com2sec noConfigUser default <변경값>",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 49,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-08",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n불필요한 서비스가 동작하고 있는지 확인 후 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 50,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-01",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf(/etc/rsyslog.conf)에서 인증과 관련된 서비스를 별도의 파일로 기록하도록 설정\n - auth.notice /var/adm/sulog",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 51,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-02",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf(/etc/rsyslog.conf)에 각 서비스별 로그를 기록하도록 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 52,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX6-01",
        "asset_spec": "centos",
        "suggest_desc": "■ 권고사항\n최신보안 패치 및 벤더 권장버전을 적용하고 정기적으로 점검",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 53,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-01",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n1. root 계정 외 UID가 0인 계정 존재 시 중복되지 않은 다른 UID로 변경\n2. 불필요한 계정이면 삭제\n3. 현재 계정이 사용중이면 명령어로 조치가 안되므로 /etc/passwd 파일을 수정하여 조치",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 54,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-02",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 55,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-03",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n로그인이 불필요한 시스템 계정 또는 휴먼 계정은 /bin/false, /bin/nologin, /sbin/nologin 쉘을 부여",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 56,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-04",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n1. 새로 생성할 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/login.defs\nPASS_MIN_LEN 8\n\n2. 새로 생성할 계정에게 적용 - 패스워드 최대 사용기간\n# vi /etc/login.defs\nPASS_MAX_DAYS 90\n\n3. 기존 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/pam.d/system-auth (password-auth도 적용)\npassword    requisite     pam_cracklib.so try_first_pass retry=3 minlen=8\n\n# vi /etc/security/pwquality.conf (7 버전 이상)\nminlen = 8\n\n4. 기존 계정에게 적용 - 패스워드 최대 사용기간\n# chage -M 90 계정명",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 57,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-05",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\nsu 권한을 특정 그룹에 존재하는 사용자만 사용하도록 다음중 한가지를 선택해서 사용\n\n1. wheel 그룹 및 su 파일 권한\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /usr/bin/su의 그룹을 wheel, 권한을 4750 변경\n\n2. PAM 모듈\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /etc/pam.d/su 파일의 내용을 auth requisite pam_group.so no_warn group=wheel\n - /usr/bin/su의 그룹을 wheel 변경\n - 참고 : PAM은 일반 사용자에게 적용 받는 모듈임",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 58,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-06",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n패스워드를 영문, 숫자, 특수 문자 3가지 조합 8자리 이상 또는 2가지 조합 10자리 이상으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 59,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-01",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n1. /etc/passwd 파일의 권한을 644 이하로 설정\n2. /etc/shadow 파일의 권한을 400으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 60,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-02",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n주요 디렉토리(/sbin, /etc, /bin, /usr/bin, /usr/sbin, /usr/lbin)에 타사용자의 쓰기 권한 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 61,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-03",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n네트워크 설정 파일(/etc/hosts, /etc/services, /etc/inetd.conf, /etc/xinetd.conf)에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 62,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-04",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n/etc/pam.d/login 설정 파일에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 63,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-05",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv, .rhosts 파일의 권한을 600 또는 400으로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 64,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-06",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf(/etc/rsyslog.conf) 파일에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 65,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-07",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n주요 로그 파일(/var/log/wtmp* /var/log/utmp* /var/log/auth.log /var/log/messages /var/log/lastlog /var/log/security)에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 66,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-01",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n/etc/profile에 umask 값을 022로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 67,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-02",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\nPATH 환경변수 현재 디렉토리를 의미하는 \".\"\" \"\"::\"\"를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 68,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-01",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n원격접근 시 서비스의 상세버전이 노출되지 않도록 제거하거나, 별도의 경고문구를 추가\n\n1. /etc/motd\n로컬 및 원격에서 로그인 성공 후 보여줄 메시지 파일로 이 파일에 로그인 시도 시 메시지를 추가\n\n2. telnet \n원격에서 접속 시도 시 보여줄 메시지 파일(/etc/issue.net)로 이 파일에 로그인 시도 시 메시지를 추가\n\n3. vsftpd\nvsftpd 설정 파일의 ftpd_banner 지시자의 주석을 제거하고 로그인 시도 시 메시지를 추가\n\n4. proftp\nproftp 설정 파일의 배너를 다음과 같이 설정\nServerName \"FTP Server\"\"",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 69,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-02",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n불필요한 RPC 서비스를 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 70,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-03",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n불필요한 r 서비스(rsh, rlogin, rexec)를 중지하고, 필요하지 않다면 해당 서비스를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 71,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-04",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv 파일에서 특정 호스트한 허용하도록 설정\n\nweb test : web 호스트의 test 사용자만 허용",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 72,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-05",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n1. vsftpd\nvsftpd 설정 파일에서 anonymous_enable=NO로 설정\n\n2. proftp\n- proftp 설정 파일에서 Anonymous 섹션을 전체 삭제\n- proftp 설정 파일에서 Anonymous 섹션이 존재할 경우 해당 섹션 내의 User로 설정된 계정을 userdel 명령어로 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 73,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-06",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n1. /etc/pam.d/login 파일에서 account requisite pam_securetty.so 라인의 주석을 제거\n2. /etc/securetty 파일의 pts/1, pts/2 .. 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 74,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-07",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n1. SNMP 서비스를 사용하지 않으면 중지\n2. SNMP 서비스 사용 시 SNMP 설정 파일에서 다음과 같이 설정\n - com2sec noConfigUser default <변경값>",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 75,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-08",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n불필요한 서비스가 동작하고 있는지 확인 후 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 76,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-01",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf(/etc/rsyslog.conf)에서 인증과 관련된 서비스를 별도의 파일로 기록하도록 설정\n - auth.notice /var/adm/sulog",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 77,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-02",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf(/etc/rsyslog.conf)에 각 서비스별 로그를 기록하도록 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 78,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX6-01",
        "asset_spec": "redhat",
        "suggest_desc": "■ 권고사항\n최신보안 패치 및 벤더 권장버전을 적용하고 정기적으로 점검",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 79,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-01",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n1. root 계정 외 UID가 0인 계정 존재 시 중복되지 않은 다른 UID로 변경\n2. 불필요한 계정이면 삭제\n3. 현재 계정이 사용중이면 명령어로 조치가 안되므로 /etc/passwd 파일을 수정하여 조치",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 80,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-02",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 81,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-03",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n로그인이 불필요한 시스템 계정 또는 휴먼 계정은 /bin/false, /bin/nologin, /sbin/nologin 쉘을 부여",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 82,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-04",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n1. 새로 생성할 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/login.defs\nPASS_MIN_LEN 8\n\n2. 새로 생성할 계정에게 적용 - 패스워드 최대 사용기간\n# vi /etc/login.defs\nPASS_MAX_DAYS 90\n\n3. 기존 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/pam.d/system-auth (password-auth도 적용)\npassword    requisite     pam_cracklib.so try_first_pass retry=3 minlen=8\n\n# vi /etc/security/pwquality.conf (7 버전 이상)\nminlen = 8\n\n4. 기존 계정에게 적용 - 패스워드 최대 사용기간\n# chage -M 90 계정명",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 83,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-05",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\nsu 권한을 특정 그룹에 존재하는 사용자만 사용하도록 다음중 한가지를 선택해서 사용\n\n1. wheel 그룹 및 su 파일 권한\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /usr/bin/su의 그룹을 wheel, 권한을 4750 변경\n\n2. PAM 모듈\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /etc/pam.d/su 파일의 내용을 auth requisite pam_group.so no_warn group=wheel\n - /usr/bin/su의 그룹을 wheel 변경\n - 참고 : PAM은 일반 사용자에게 적용 받는 모듈임",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 84,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-06",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n패스워드를 영문, 숫자, 특수 문자 3가지 조합 8자리 이상 또는 2가지 조합 10자리 이상으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 85,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-01",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n1. /etc/passwd 파일의 권한을 644 이하로 설정\n2. /etc/shadow 파일의 권한을 400으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 86,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-02",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n주요 디렉토리(/sbin, /etc, /bin, /usr/bin, /usr/sbin, /usr/lbin)에 타사용자의 쓰기 권한 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 87,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-03",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n네트워크 설정 파일(/etc/hosts, /etc/services, /etc/inetd.conf, /etc/xinetd.conf)에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 88,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-04",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n/etc/pam.d/login 설정 파일에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 89,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-05",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv, .rhosts 파일의 권한을 600 또는 400으로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 90,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-06",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf(/etc/rsyslog.conf) 파일에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 91,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-07",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n주요 로그 파일(/var/log/wtmp* /var/log/utmp* /var/log/auth.log /var/log/messages /var/log/lastlog /var/log/security)에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 92,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-01",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n/etc/profile에 umask 값을 022로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 93,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-02",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\nPATH 환경변수 현재 디렉토리를 의미하는 \".\"\" \"\"::\"\"를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 94,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-01",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n원격접근 시 서비스의 상세버전이 노출되지 않도록 제거하거나, 별도의 경고문구를 추가\n\n1. /etc/motd\n로컬 및 원격에서 로그인 성공 후 보여줄 메시지 파일로 이 파일에 로그인 시도 시 메시지를 추가\n\n2. telnet \n원격에서 접속 시도 시 보여줄 메시지 파일(/etc/issue.net)로 이 파일에 로그인 시도 시 메시지를 추가\n\n3. vsftpd\nvsftpd 설정 파일의 ftpd_banner 지시자의 주석을 제거하고 로그인 시도 시 메시지를 추가\n\n4. proftp\nproftp 설정 파일의 배너를 다음과 같이 설정\nServerName \"FTP Server\"\"",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 95,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-02",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n불필요한 RPC 서비스를 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 96,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-03",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n불필요한 r 서비스(rsh, rlogin, rexec)를 중지하고, 필요하지 않다면 해당 서비스를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 97,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-04",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv 파일에서 특정 호스트한 허용하도록 설정\n\nweb test : web 호스트의 test 사용자만 허용",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 98,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-05",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n1. vsftpd\nvsftpd 설정 파일에서 anonymous_enable=NO로 설정\n\n2. proftp\n- proftp 설정 파일에서 Anonymous 섹션을 전체 삭제\n- proftp 설정 파일에서 Anonymous 섹션이 존재할 경우 해당 섹션 내의 User로 설정된 계정을 userdel 명령어로 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 99,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-06",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n1. /etc/pam.d/login 파일에서 account requisite pam_securetty.so 라인의 주석을 제거\n2. /etc/securetty 파일의 pts/1, pts/2 .. 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 100,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-07",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n1. SNMP 서비스를 사용하지 않으면 중지\n2. SNMP 서비스 사용 시 SNMP 설정 파일에서 다음과 같이 설정\n - com2sec noConfigUser default <변경값>",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 101,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-08",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n불필요한 서비스가 동작하고 있는지 확인 후 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 102,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-01",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf(/etc/rsyslog.conf)에서 인증과 관련된 서비스를 별도의 파일로 기록하도록 설정\n - auth.notice /var/adm/sulog",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 103,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-02",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf(/etc/rsyslog.conf)에 각 서비스별 로그를 기록하도록 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 104,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX6-01",
        "asset_spec": "linux",
        "suggest_desc": "■ 권고사항\n최신보안 패치 및 벤더 권장버전을 적용하고 정기적으로 점검",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 105,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-01",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n1. root 계정 외 UID가 0인 계정 존재 시 중복되지 않은 다른 UID로 변경\n2. 불필요한 계정이면 삭제\n3. 현재 계정이 사용중이면 명령어로 조치가 안되므로 /etc/passwd 파일을 수정하여 조치",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 106,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-02",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 107,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-03",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n로그인이 불필요한 시스템 계정 또는 휴먼 계정은 /bin/false, /bin/nologin, /sbin/nologin 쉘을 부여",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 108,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-04",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n1. 새로 생성할 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/default/security\nMIN_PASSWORD_LENGTH=8\n\n2. 새로 생성할 계정에게 적용 - 패스워드 최대 사용기간\n# vi /etc/default/security\nPASSWORD_MAXDAYS=90\n",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 109,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-05",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\nsu 권한을 특정 그룹에 존재하는 사용자만 사용하도록 다음중 한가지를 선택해서 사용\n\n1. wheel 그룹 및 su 파일 권한\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /etc/default/security에서 SU_ROOT_GROUP=wheel \n - /usr/bin/su의 그룹을 wheel, 권한을 4750 변경\n",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 110,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-06",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n패스워드를 영문, 숫자, 특수 문자 3가지 조합 8자리 이상 또는 2가지 조합 10자리 이상으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 111,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-01",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n1. /etc/passwd 파일의 권한을 644 이하로 설정\n2. /etc/shadow 파일의 권한을 400으로 설정 or\n   /tcb/files/auth/ 디렉토리의 권한을 400으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 112,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-02",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n주요 디렉토리(/sbin, /etc, /bin, /usr/bin, /usr/sbin, /usr/lbin)에 타사용자의 쓰기 권한 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 113,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-03",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n네트워크 설정 파일(/etc/hosts, /etc/services, /etc/inetd.conf)에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 114,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-04",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n/etc/securetty 설정 파일에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 115,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-05",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv, .rhosts 파일의 권한을 600 또는 400으로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 116,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-06",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf 파일에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 117,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-07",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n주요 로그 파일(/var/adm/wtmp* /var/adm/utmp* /var/adm/btmp* /var/adm/messages /var/adm/loginlog /var/adm/lastlog /var/adm/sulog /var/log/authlog /var/log/syslog)에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 118,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-01",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n/etc/profile(/etc/default/security)에 umask 값을 022로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 119,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-02",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\nPATH 환경변수 현재 디렉토리를 의미하는 \".\"\" \"\"::\"\"를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 120,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-01",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n원격접근 시 서비스의 상세버전이 노출되지 않도록 제거하거나, 별도의 경고문구를 추가\n\n1. /etc/motd\n - 로컬 및 원격에서 로그인 성공 후 보여줄 메시지 파일로 이 파일레 로그인 시도 시 메시지를 추가\n\n2. telnet (/etc/inetd.conf)\n - telnet stream tcp6 nowait root /usr/lbin/telnetd telnetd -b /etc/issue\n - /etc/issue 파일에 배너 추가\n\n3. ftp (/etc/inetd.conf)\n - ftp stream tcp nowait root /usr/lbin/ftpd ftpd -a /etc/ftpd/ftpaccess\n - /etc/ftpd/ftpaccess에 hostname, version 제거\n\n4. proftp\n - proftp 설정 파일의 배너를 다음과 같이 설정\n - ServerName \"FTP Server\"\"",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 121,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-02",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n불필요한 RPC 서비스를 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 122,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-03",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n불필요한 r 서비스(rsh, rlogin, rexec)를 중지하고, 필요하지 않다면 해당 서비스를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 123,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-04",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv 파일에서 특정 호스트한 허용하도록 설정\n\nweb test : web 호스트의 test 사용자만 허용",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 124,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-05",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n1. vsftpd\nvsftpd 설정 파일에서 anonymous_enable=NO로 설정\n\n2. proftp\n- proftp 설정 파일에서 Anonymous 섹션을 전체 삭제\n- proftp 설정 파일에서 Anonymous 섹션이 존재할 경우 해당 섹션 내의 User로 설정된 계정을 userdel 명령어로 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 125,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-06",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n1. /etc/securetty 파일에서 console 라인의 주석을 제거\n2. /etc/securetty 파일의 pts/1, pts/2 .. 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 126,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-07",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n1. SNMP 서비스를 사용하지 않으면 중지\n2. SNMP 서비스 사용 시 SNMP 설정 파일에서 다음과 같이 설정\n - get-community-name: <변경 값〉 / set-commnunity-name: <변경 값〉",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 127,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-08",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n불필요한 서비스가 동작하고 있는지 확인 후 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 128,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-01",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf에서 인증과 관련된 서비스를 별도의 파일로 기록하도록 설정\n - auth.notice /var/adm/sulog",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 129,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-02",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf에 각 서비스별 로그를 기록하도록 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 130,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX6-01",
        "asset_spec": "hp-ux",
        "suggest_desc": "■ 권고사항\n최신보안 패치 및 벤더 권장버전을 적용하고 정기적으로 점검",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 131,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-01",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n1. root 계정 외 UID가 0인 계정 존재 시 중복되지 않은 다른 UID로 변경\n2. 불필요한 계정이면 삭제\n3. 현재 계정이 사용중이면 명령어로 조치가 안되므로 /etc/passwd 파일을 수정하여 조치",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 132,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-02",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 133,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-03",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n로그인이 불필요한 시스템 계정 또는 휴먼 계정은 /bin/false, /bin/nologin, /sbin/nologin 쉘을 부여",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 134,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-04",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n1. 새로 생성할 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/default/passwd\nPASSLENGTH=8\n\n2. 새로 생성할 계정에게 적용 - 패스워드 최대 사용기간\n# vi /etc/default/passwd\nMAXWEEKS=12\n",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 135,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-05",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\nsu 권한을 특정 그룹에 존재하는 사용자만 사용하도록 다음중 한가지를 선택해서 사용\n\n1. wheel 그룹 및 su 파일 권한\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /usr/bin/su의 그룹을 wheel, 권한을 4750 변경\n",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 136,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-06",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n패스워드를 영문, 숫자, 특수 문자 3가지 조합 8자리 이상 또는 2가지 조합 10자리 이상으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 137,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-01",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n1. /etc/passwd 파일의 권한을 644 이하로 설정\n2. /etc/shadow 파일의 권한을 400으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 138,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-02",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n주요 디렉토리(/sbin, /etc, /bin, /usr/bin, /usr/sbin, /usr/lbin)에 타사용자의 쓰기 권한 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 139,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-03",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n네트워크 설정 파일(/etc/hosts, /etc/services, /etc/inetd.conf)에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 140,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-04",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n/etc/default/login 설정 파일에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 141,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-05",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv, .rhosts 파일의 권한을 600 또는 400으로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 142,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-06",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf 파일에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 143,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-07",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n주요 로그 파일(/var/log/wtmp* /var/log/utmp* /var/log/auth.log /var/log/messages /var/log/lastlog /var/log/security or /var/adm/*)에 타사용자 쓰기 권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 144,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-01",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n/etc/profile(/etc/default/login)에 umask 값을 022로 변경",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 145,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX3-02",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\nPATH 환경변수 현재 디렉토리를 의미하는 \".\"\" \"\"::\"\"를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 146,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-01",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n원격접근 시 서비스의 상세버전이 노출되지 않도록 제거하거나, 별도의 경고문구를 추가\n\n1. /etc/motd\n - 로컬 및 원격에서 로그인 성공 후 보여줄 메시지 파일로 이 파일레 로그인 시도 시 메시지를 추가\n\n2. telnet (/etc/default/telnetd)\n - BANNER=MWARNING:Authorized use only\" or BANNER=\"\"\"\"",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 147,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-02",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n불필요한 RPC 서비스를 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 148,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-03",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n불필요한 r 서비스(rsh, rlogin, rexec)를 중지하고, 필요하지 않다면 해당 서비스를 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 149,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-04",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n/etc/hosts.equiv 파일에서 특정 호스트한 허용하도록 설정\n\nweb test : web 호스트의 test 사용자만 허용",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 150,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-05",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n1. vsftpd\nvsftpd 설정 파일에서 anonymous_enable=NO로 설정\n\n2. proftp\n- proftp 설정 파일에서 Anonymous 섹션을 전체 삭제\n- proftp 설정 파일에서 Anonymous 섹션이 존재할 경우 해당 섹션 내의 User로 설정된 계정을 userdel 명령어로 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 151,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-06",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n1. /etc/default/login 파일에서 CONSOLE=/dev/console 라인의 주석을 제거\n2. /etc/securetty 파일의 pts/1, pts/2 .. 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 152,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-07",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n1. SNMP 서비스를 사용하지 않으면 중지\n2. SNMP 서비스 사용 시 SNMP 설정 파일에서 다음과 같이 설정\n - read-community <변경 값> / write-community <변경 값> (Solaris 9 버전 이하)\n - rocommunity <변경 값> / rwcommunity <변경 값> (Solaris 10 버전 이상)",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 153,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX4-08",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n불필요한 서비스가 동작하고 있는지 확인 후 중지",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 154,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-01",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf에서 인증과 관련된 서비스를 별도의 파일로 기록하도록 설정\n - auth.notice /var/adm/sulog",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 155,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX5-02",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n/etc/syslog.conf에 각 서비스별 로그를 기록하도록 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 156,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX6-01",
        "asset_spec": "solaris",
        "suggest_desc": "■ 권고사항\n최신보안 패치 및 벤더 권장버전을 적용하고 정기적으로 점검",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 157,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-01",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\n1. root 계정 외 UID가 0인 계정 존재 시 중복되지 않은 다른 UID로 변경\n2. 불필요한 계정이면 삭제\n3. 현재 계정이 사용중이면 명령어로 조치가 안되므로 /etc/passwd 파일을 수정하여 조치",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 158,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-02",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\n오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 159,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-03",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\n로그인이 불필요한 시스템 계정 또는 휴먼 계정은 /bin/false, /bin/nologin, /sbin/nologin 쉘을 부여",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 160,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-04",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\n1. 새로 생성할 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/default/passwd\nPASSLENGTH=8\n\n2. 새로 생성할 계정에게 적용 - 패스워드 최대 사용기간\n# vi /etc/default/passwd\nMAXWEEKS=12\n",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 161,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-05",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\nsu 권한을 특정 그룹에 존재하는 사용자만 사용하도록 다음중 한가지를 선택해서 사용\n\n1. wheel 그룹 및 su 파일 권한\n - /etc/group에서 wheel 그룹의 구성원 추가\n - /usr/bin/su의 그룹을 wheel, 권한을 4750 변경\n",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 162,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX1-06",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\n패스워드를 영문, 숫자, 특수 문자 3가지 조합 8자리 이상 또는 2가지 조합 10자리 이상으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 163,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-01",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\n1. /etc/passwd 파일의 권한을 644 이하로 설정\n2. /etc/shadow 파일의 권한을 400으로 설정",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 164,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-02",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\n주요 디렉토리(/sbin, /etc, /bin, /usr/bin, /usr/sbin, /usr/lbin)에 타사용자의 쓰기 권한 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 165,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-03",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\n네트워크 설정 파일(/etc/hosts, /etc/services, /etc/inetd.conf)에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    },
    {
        "id": 166,
        "report_id": "CM001_US_2023_0001",
        "measure_cd": "LX2-04",
        "asset_spec": "sunos",
        "suggest_desc": "■ 권고사항\n/etc/default/login 설정 파일에 타사용자 쓰기권한을 제거",
        "sys_reg_user": null,
        "sys_reg_date": null,
        "sys_mod_user": null,
        "sys_mod_date": null
    }
    ]



    export const threatListData = [
        {
            "id": 1,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-01",
            "threat_type": "T",
            "threat_nm": "외부 네트워크 서비스 장애",
            "threat_desc": "IDC의 통신서비스 장애 및 DDoS공격으로 인한 회선용량 부족(예:Traffic 폭주로 인한 네트워크 Down, 네트워크의 물리적 파손, 전자메일 폭주)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 2,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-02",
            "threat_type": "T",
            "threat_nm": "내부 네트워크 서비스 장애",
            "threat_desc": "네트워크 장비/케이블(구성요소)의 고장 및 장애로 인한 네트워크 서비스 중단, 과도한 트래픽 발생",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 3,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-03",
            "threat_type": "T",
            "threat_nm": "하드웨어 장애",
            "threat_desc": "하드웨어 파괴, PC고장, 서버고장, 저장매체의 노후로 인한 장애, 프린터의 장애",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 4,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-04",
            "threat_type": "T",
            "threat_nm": "OS 장애",
            "threat_desc": "OS의 오작동 및 정지",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 5,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-05",
            "threat_type": "T",
            "threat_nm": "응용시스템 장애",
            "threat_desc": "응용프로그램, 데이터베이스, 미들웨어의 고장 및 장애",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 6,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-06",
            "threat_type": "T",
            "threat_nm": "사용자 인증 및 패스워드 침해",
            "threat_desc": "사용자 계정 권한 및 패스워드 관리 미흡으로 인한 불법적인 공격 또는 기밀정보 유출",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 7,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-07",
            "threat_type": "T",
            "threat_nm": "환경설정의 미흡 비인가자 접근",
            "threat_desc": "시스템환경 설정의 미흡으로 비인가자에 의한 불법적인 시스템 환경 수정 발생",
            "strength_grd": "M",
            "frequency_grd": "M",
            "intensity_score": 2,
            "frequency_score": 2,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 8,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-08",
            "threat_type": "T",
            "threat_nm": "불필요한 서비스 제공 비인가자 접근",
            "threat_desc": "불필요한 서비스 제공 및 통제미흡으로(웹취약점 통제 포함) 보안취약 서비스를 이용한 불법적인 침해시도를 통한 내부정보 유출(예:고객 개인정보 등)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 9,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-09",
            "threat_type": "T",
            "threat_nm": "응용시스템 취약 및 신규 취약점으로 인한 비인가자 접근",
            "threat_desc": "응용시스템 또는 응용이 이용하는 서비스나 프로그래밍 방식이 취약하거나 새로운 취약성이 발견되어 허가되지 않은 자의 접근가능",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 10,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-10",
            "threat_type": "T",
            "threat_nm": "원격관리 미흡으로 비인가자 접근",
            "threat_desc": "네트워크 접근통제 미흡으로 원격 관리 기능을 통해 허가받지 않은 자가 네트워크에 접근할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 11,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-11",
            "threat_type": "T",
            "threat_nm": "로그분석 및 보관 부재",
            "threat_desc": "로그를 분석하거나 보관하지 않아 보안 위반의 발생 여부나 책임자 확인이 불가능 할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 12,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-12",
            "threat_type": "T",
            "threat_nm": "정보의 무결성 손실",
            "threat_desc": "전자정보(데이터, 전자문서 등)에 대한 비인가자에 의한 임의적 변경 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 13,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-13",
            "threat_type": "T",
            "threat_nm": "악성소프트웨어 공격",
            "threat_desc": "웜 및 바이러스에 의한 정보시스템 장애 및 정보유출 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 14,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TT-14",
            "threat_type": "T",
            "threat_nm": "해킹발생",
            "threat_desc": "해커, 크래커, 컴퓨터범죄자, 산업스파이, 정부지원 스파이 등에 의한 정보시스템 장애 및 정보유출 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 15,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-01",
            "threat_type": "M",
            "threat_nm": "보안규정",
            "threat_desc": "보안 정책/지침/절차의 부적정성, 보안규정 미준수로 인한 보안사고의 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 16,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-02",
            "threat_type": "M",
            "threat_nm": "보안조직",
            "threat_desc": "보안조직의 인원 및 역량 부족으로 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 17,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-03",
            "threat_type": "M",
            "threat_nm": "자산관리",
            "threat_desc": "자산의 중요도 및 특성이 분류되지 않아 통제가 부족하거나 과도한 통제로 비용과 노력이 낭비\n(노트북 등 이동 컴퓨팅 장비에 대한 통제부족으로 장비가 이동 중 분실, 도난, 손상 등이 발생 할 수 있음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 18,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-04",
            "threat_type": "M",
            "threat_nm": "외부직원 계약",
            "threat_desc": "위탁회사와의 계약 시 보안요구사항을 명시하지 않아 위탁 운영되는 자산에 대한 보안이 필요 수준에 미흡할 수 있음\n(중요한 시스템을 운영하는 인력에 대한 신원조회, 전문성 등의 검증이 이루어지지 않을 수 있음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 19,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-05",
            "threat_type": "M",
            "threat_nm": "외부직원",
            "threat_desc": " 외부자(용역,아웃소싱 등)에 의한 권한 내 데이터 유출, 변조 및 파괴",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 20,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-06",
            "threat_type": "M",
            "threat_nm": "전문성 및 전담 인력",
            "threat_desc": "인력의 전문성 및 전담 인력의 부족하거나 과도한 통제로 비용과 노력이 낭비 될 수 있음",
            "strength_grd": "M",
            "frequency_grd": "M",
            "intensity_score": 2,
            "frequency_score": 2,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 21,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-07",
            "threat_type": "M",
            "threat_nm": "교육 및 훈련",
            "threat_desc": "임직원 및 외주업체직원의 보안인식 및 업무기능과 관련된 교육 및 훈련 부족으로 보안사고 발생\n(위탁회사의 정보보호대책이 부족하거나 인력의 보안의식 부재로 인해 자산이 보호되지 않음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 22,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-08",
            "threat_type": "M",
            "threat_nm": "내부직원",
            "threat_desc": "내부자에 의한 권한 내 데이터 유출, 변조 및 파괴\n(중요 직무가 분류되지 않아 통제가 부족하거나 과도한 통제로 비용과 노력이 낭비 될 수 있음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 23,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-09",
            "threat_type": "M",
            "threat_nm": "운영실수",
            "threat_desc": "내부전산운영요원, 외부유지보수인력, 사용자, 직원의 실수, 부주의에 의한 보안사고 발생\n(보안시스템의 운영 관리에 대한 통제 부족으로 허가되지 않은 보안 통제의 변경이 발생할 있음)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 24,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-10",
            "threat_type": "M",
            "threat_nm": "운영절차",
            "threat_desc": "운영절차의 문서화 미비 및 오류로 인한 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 25,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-11",
            "threat_type": "M",
            "threat_nm": "변경 및 승인 ",
            "threat_desc": "정보 및 설비에 대한 변경 및 승인 미흡으로 보안사고 발생 \n(예:허가받지 않고 운영중인 시스템의 프로그램 등 변경하여 시행)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 26,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-12",
            "threat_type": "M",
            "threat_nm": "응용 프로그램 보안기능 부족",
            "threat_desc": "- 응용프로그램 도입 또는 개발 시 보안 요구사항을 명시하지 않아 도입될 응용 프로그램에 보안기능이 부족으로 인한 보안위협                                                                                                                                                                                                                                                 (응용 프로그램의 소스 라이브러리에 허가 없이 접근 변경)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 27,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-13",
            "threat_type": "M",
            "threat_nm": "불법소프트웨어 사용",
            "threat_desc": "불법 소프트웨어 사용에 의한 장애 및 정보유출 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 28,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-14",
            "threat_type": "M",
            "threat_nm": "정보 백업",
            "threat_desc": "중요 정보에 대한 백업 및 백업매체 보관 미비",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 29,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-15",
            "threat_type": "M",
            "threat_nm": "문서 및 기록의 보호",
            "threat_desc": "보안관련 문서 및 기록 관리 미흡으로 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 30,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-16",
            "threat_type": "M",
            "threat_nm": "자산 폐기 관리의 보호",
            "threat_desc": "PC 또는 서버 등 정보자산의 폐기 또는 사용자 전환 시 허가되지 않은 데이터 노출이 발생할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 31,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-17",
            "threat_type": "M",
            "threat_nm": "보안사고 관리",
            "threat_desc": "보안사고에 대한 신속한 대응체계 미비 및 업무연속성을 위한 재해복구계획 미비",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 32,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-18",
            "threat_type": "M",
            "threat_nm": "법 및 계약 요구사항",
            "threat_desc": "- 법적 요구사항, 계약 상 지켜야 할 사항을 알지 못할 수 있음\n- 법적 요구사항, 계약 상 지켜야 할 사항을 알고도 통제가 부족하여 지키지 못할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 33,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-19",
            "threat_type": "M",
            "threat_nm": "보안감사",
            "threat_desc": "보안 검토,모니터링,감사에 대한 미흡으로 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 34,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-20",
            "threat_type": "M",
            "threat_nm": "네트워크 미분리 사용",
            "threat_desc": "운영 및 테스트 환경의 미분리(운영 및 테스트 데이터의 혼용 사용)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 35,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TM-21",
            "threat_type": "M",
            "threat_nm": "저장매체 통제",
            "threat_desc": "비인가 저장매체 사용(예:CDRW, USB 등) 통제 미흡으로 내부정보 유출",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 36,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-01",
            "threat_type": "P",
            "threat_nm": "화재",
            "threat_desc": "화재에 의한 정보자산의 훼손",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 37,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-02",
            "threat_type": "P",
            "threat_nm": "수재",
            "threat_desc": "수재(소화장비 오류,누수,화장실 물 등)에 의한 정보자산의 훼손 및 장애",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 38,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-03",
            "threat_type": "P",
            "threat_nm": "전력공급중단",
            "threat_desc": "전력공급 실패, 불안정한 전력의 공급, UPS 용량부족",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 39,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-04",
            "threat_type": "P",
            "threat_nm": "물리적 접근",
            "threat_desc": "절도 및 비인가 유출 등 보호구역에 대한 접근통제 미흡",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 40,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-05",
            "threat_type": "P",
            "threat_nm": "온/습도 조절장치(항온항습기,에어컨)",
            "threat_desc": "온/습도 조절장치의 고장, 장애",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 41,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-06",
            "threat_type": "P",
            "threat_nm": "파업",
            "threat_desc": "파업에 의한 정보자산  훼손",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 42,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-07",
            "threat_type": "P",
            "threat_nm": "테러",
            "threat_desc": "테러, 전쟁, 군사훈련, 근접한 폭발시설 등에 의한 정보자산 훼손",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 43,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-08",
            "threat_type": "P",
            "threat_nm": "폭동",
            "threat_desc": "폭동에 의한 정보자산 훼손",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 44,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-09",
            "threat_type": "P",
            "threat_nm": "자연재해",
            "threat_desc": "자연재해(예:폭풍,홍수,낙뢰,지진,눈사태,황사,방사능 등)에 의한 정보자산 훼손",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 45,
            "report_id": "CM001_US_2023_0001",
            "threat_cd": "TP-10",
            "threat_type": "P",
            "threat_nm": "산업재해",
            "threat_desc": "산업재해에 의한 정보자산 훼손",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 46,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-01",
            "threat_type": "T",
            "threat_nm": "외부 네트워크 서비스 장애",
            "threat_desc": "IDC의 통신서비스 장애 및 DDoS공격으로 인한 회선용량 부족(예:Traffic 폭주로 인한 네트워크 Down, 네트워크의 물리적 파손, 전자메일 폭주)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 47,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-02",
            "threat_type": "T",
            "threat_nm": "내부 네트워크 서비스 장애",
            "threat_desc": "네트워크 장비/케이블(구성요소)의 고장 및 장애로 인한 네트워크 서비스 중단, 과도한 트래픽 발생",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 48,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-03",
            "threat_type": "T",
            "threat_nm": "하드웨어 장애",
            "threat_desc": "하드웨어 파괴, PC고장, 서버고장, 저장매체의 노후로 인한 장애, 프린터의 장애",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 49,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-04",
            "threat_type": "T",
            "threat_nm": "OS 장애",
            "threat_desc": "OS의 오작동 및 정지",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 50,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-05",
            "threat_type": "T",
            "threat_nm": "응용시스템 장애",
            "threat_desc": "응용프로그램, 데이터베이스, 미들웨어의 고장 및 장애",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 51,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-06",
            "threat_type": "T",
            "threat_nm": "사용자 인증 및 패스워드 침해",
            "threat_desc": "사용자 계정 권한 및 패스워드 관리 미흡으로 인한 불법적인 공격 또는 기밀정보 유출",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 52,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-07",
            "threat_type": "T",
            "threat_nm": "환경설정의 미흡 비인가자 접근",
            "threat_desc": "시스템환경 설정의 미흡으로 비인가자에 의한 불법적인 시스템 환경 수정 발생",
            "strength_grd": "M",
            "frequency_grd": "M",
            "intensity_score": 2,
            "frequency_score": 2,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 53,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-08",
            "threat_type": "T",
            "threat_nm": "불필요한 서비스 제공 비인가자 접근",
            "threat_desc": "불필요한 서비스 제공 및 통제미흡으로(웹취약점 통제 포함) 보안취약 서비스를 이용한 불법적인 침해시도를 통한 내부정보 유출(예:고객 개인정보 등)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 54,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-09",
            "threat_type": "T",
            "threat_nm": "응용시스템 취약 및 신규 취약점으로 인한 비인가자 접근",
            "threat_desc": "응용시스템 또는 응용이 이용하는 서비스나 프로그래밍 방식이 취약하거나 새로운 취약성이 발견되어 허가되지 않은 자의 접근가능",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 55,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-10",
            "threat_type": "T",
            "threat_nm": "원격관리 미흡으로 비인가자 접근",
            "threat_desc": "네트워크 접근통제 미흡으로 원격 관리 기능을 통해 허가받지 않은 자가 네트워크에 접근할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 56,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-11",
            "threat_type": "T",
            "threat_nm": "로그분석 및 보관 부재",
            "threat_desc": "로그를 분석하거나 보관하지 않아 보안 위반의 발생 여부나 책임자 확인이 불가능 할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 57,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-12",
            "threat_type": "T",
            "threat_nm": "정보의 무결성 손실",
            "threat_desc": "전자정보(데이터, 전자문서 등)에 대한 비인가자에 의한 임의적 변경 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 58,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-13",
            "threat_type": "T",
            "threat_nm": "악성소프트웨어 공격",
            "threat_desc": "웜 및 바이러스에 의한 정보시스템 장애 및 정보유출 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 59,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TT-14",
            "threat_type": "T",
            "threat_nm": "해킹발생",
            "threat_desc": "해커, 크래커, 컴퓨터범죄자, 산업스파이, 정부지원 스파이 등에 의한 정보시스템 장애 및 정보유출 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 60,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-01",
            "threat_type": "M",
            "threat_nm": "보안규정",
            "threat_desc": "보안 정책/지침/절차의 부적정성, 보안규정 미준수로 인한 보안사고의 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 61,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-02",
            "threat_type": "M",
            "threat_nm": "보안조직",
            "threat_desc": "보안조직의 인원 및 역량 부족으로 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 62,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-03",
            "threat_type": "M",
            "threat_nm": "자산관리",
            "threat_desc": "자산의 중요도 및 특성이 분류되지 않아 통제가 부족하거나 과도한 통제로 비용과 노력이 낭비\n(노트북 등 이동 컴퓨팅 장비에 대한 통제부족으로 장비가 이동 중 분실, 도난, 손상 등이 발생 할 수 있음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 63,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-04",
            "threat_type": "M",
            "threat_nm": "외부직원 계약",
            "threat_desc": "위탁회사와의 계약 시 보안요구사항을 명시하지 않아 위탁 운영되는 자산에 대한 보안이 필요 수준에 미흡할 수 있음\n(중요한 시스템을 운영하는 인력에 대한 신원조회, 전문성 등의 검증이 이루어지지 않을 수 있음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 64,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-05",
            "threat_type": "M",
            "threat_nm": "외부직원",
            "threat_desc": " 외부자(용역,아웃소싱 등)에 의한 권한 내 데이터 유출, 변조 및 파괴",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 65,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-06",
            "threat_type": "M",
            "threat_nm": "전문성 및 전담 인력",
            "threat_desc": "인력의 전문성 및 전담 인력의 부족하거나 과도한 통제로 비용과 노력이 낭비 될 수 있음",
            "strength_grd": "M",
            "frequency_grd": "M",
            "intensity_score": 2,
            "frequency_score": 2,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 66,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-07",
            "threat_type": "M",
            "threat_nm": "교육 및 훈련",
            "threat_desc": "임직원 및 외주업체직원의 보안인식 및 업무기능과 관련된 교육 및 훈련 부족으로 보안사고 발생\n(위탁회사의 정보보호대책이 부족하거나 인력의 보안의식 부재로 인해 자산이 보호되지 않음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 67,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-08",
            "threat_type": "M",
            "threat_nm": "내부직원",
            "threat_desc": "내부자에 의한 권한 내 데이터 유출, 변조 및 파괴\n(중요 직무가 분류되지 않아 통제가 부족하거나 과도한 통제로 비용과 노력이 낭비 될 수 있음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 68,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-09",
            "threat_type": "M",
            "threat_nm": "운영실수",
            "threat_desc": "내부전산운영요원, 외부유지보수인력, 사용자, 직원의 실수, 부주의에 의한 보안사고 발생\n(보안시스템의 운영 관리에 대한 통제 부족으로 허가되지 않은 보안 통제의 변경이 발생할 있음)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 69,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-10",
            "threat_type": "M",
            "threat_nm": "운영절차",
            "threat_desc": "운영절차의 문서화 미비 및 오류로 인한 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 70,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-11",
            "threat_type": "M",
            "threat_nm": "변경 및 승인 ",
            "threat_desc": "정보 및 설비에 대한 변경 및 승인 미흡으로 보안사고 발생 \n(예:허가받지 않고 운영중인 시스템의 프로그램 등 변경하여 시행)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 71,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-12",
            "threat_type": "M",
            "threat_nm": "응용 프로그램 보안기능 부족",
            "threat_desc": "- 응용프로그램 도입 또는 개발 시 보안 요구사항을 명시하지 않아 도입될 응용 프로그램에 보안기능이 부족으로 인한 보안위협                                                                                                                                                                                                                                                 (응용 프로그램의 소스 라이브러리에 허가 없이 접근 변경)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 72,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-13",
            "threat_type": "M",
            "threat_nm": "불법소프트웨어 사용",
            "threat_desc": "불법 소프트웨어 사용에 의한 장애 및 정보유출 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 73,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-14",
            "threat_type": "M",
            "threat_nm": "정보 백업",
            "threat_desc": "중요 정보에 대한 백업 및 백업매체 보관 미비",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 74,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-15",
            "threat_type": "M",
            "threat_nm": "문서 및 기록의 보호",
            "threat_desc": "보안관련 문서 및 기록 관리 미흡으로 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 75,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-16",
            "threat_type": "M",
            "threat_nm": "자산 폐기 관리의 보호",
            "threat_desc": "PC 또는 서버 등 정보자산의 폐기 또는 사용자 전환 시 허가되지 않은 데이터 노출이 발생할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 76,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-17",
            "threat_type": "M",
            "threat_nm": "보안사고 관리",
            "threat_desc": "보안사고에 대한 신속한 대응체계 미비 및 업무연속성을 위한 재해복구계획 미비",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 77,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-18",
            "threat_type": "M",
            "threat_nm": "법 및 계약 요구사항",
            "threat_desc": "- 법적 요구사항, 계약 상 지켜야 할 사항을 알지 못할 수 있음\n- 법적 요구사항, 계약 상 지켜야 할 사항을 알고도 통제가 부족하여 지키지 못할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 78,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-19",
            "threat_type": "M",
            "threat_nm": "보안감사",
            "threat_desc": "보안 검토,모니터링,감사에 대한 미흡으로 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 79,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-20",
            "threat_type": "M",
            "threat_nm": "네트워크 미분리 사용",
            "threat_desc": "운영 및 테스트 환경의 미분리(운영 및 테스트 데이터의 혼용 사용)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 80,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TM-21",
            "threat_type": "M",
            "threat_nm": "저장매체 통제",
            "threat_desc": "비인가 저장매체 사용(예:CDRW, USB 등) 통제 미흡으로 내부정보 유출",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 81,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-01",
            "threat_type": "P",
            "threat_nm": "화재",
            "threat_desc": "화재에 의한 정보자산의 훼손",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 82,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-02",
            "threat_type": "P",
            "threat_nm": "수재",
            "threat_desc": "수재(소화장비 오류,누수,화장실 물 등)에 의한 정보자산의 훼손 및 장애",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 83,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-03",
            "threat_type": "P",
            "threat_nm": "전력공급중단",
            "threat_desc": "전력공급 실패, 불안정한 전력의 공급, UPS 용량부족",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 84,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-04",
            "threat_type": "P",
            "threat_nm": "물리적 접근",
            "threat_desc": "절도 및 비인가 유출 등 보호구역에 대한 접근통제 미흡",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 85,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-05",
            "threat_type": "P",
            "threat_nm": "온/습도 조절장치(항온항습기,에어컨)",
            "threat_desc": "온/습도 조절장치의 고장, 장애",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 86,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-06",
            "threat_type": "P",
            "threat_nm": "파업",
            "threat_desc": "파업에 의한 정보자산  훼손",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 87,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-07",
            "threat_type": "P",
            "threat_nm": "테러",
            "threat_desc": "테러, 전쟁, 군사훈련, 근접한 폭발시설 등에 의한 정보자산 훼손",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 88,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-08",
            "threat_type": "P",
            "threat_nm": "폭동",
            "threat_desc": "폭동에 의한 정보자산 훼손",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 89,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-09",
            "threat_type": "P",
            "threat_nm": "자연재해",
            "threat_desc": "자연재해(예:폭풍,홍수,낙뢰,지진,눈사태,황사,방사능 등)에 의한 정보자산 훼손",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 90,
            "report_id": "CM001_WS_2023_0002",
            "threat_cd": "TP-10",
            "threat_type": "P",
            "threat_nm": "산업재해",
            "threat_desc": "산업재해에 의한 정보자산 훼손",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 91,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-01",
            "threat_type": "T",
            "threat_nm": "외부 네트워크 서비스 장애",
            "threat_desc": "IDC의 통신서비스 장애 및 DDoS공격으로 인한 회선용량 부족(예:Traffic 폭주로 인한 네트워크 Down, 네트워크의 물리적 파손, 전자메일 폭주)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 92,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-02",
            "threat_type": "T",
            "threat_nm": "내부 네트워크 서비스 장애",
            "threat_desc": "네트워크 장비/케이블(구성요소)의 고장 및 장애로 인한 네트워크 서비스 중단, 과도한 트래픽 발생",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 93,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-03",
            "threat_type": "T",
            "threat_nm": "하드웨어 장애",
            "threat_desc": "하드웨어 파괴, PC고장, 서버고장, 저장매체의 노후로 인한 장애, 프린터의 장애",
            "strength_grd": "M",
            "frequency_grd": "L",
            "intensity_score": 2,
            "frequency_score": 1,
            "threat_score": 3,
            "threat_grd": "L",
            "threat_grd_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 94,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-04",
            "threat_type": "T",
            "threat_nm": "OS 장애",
            "threat_desc": "OS의 오작동 및 정지",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 95,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-05",
            "threat_type": "T",
            "threat_nm": "응용시스템 장애",
            "threat_desc": "응용프로그램, 데이터베이스, 미들웨어의 고장 및 장애",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 96,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-06",
            "threat_type": "T",
            "threat_nm": "사용자 인증 및 패스워드 침해",
            "threat_desc": "사용자 계정 권한 및 패스워드 관리 미흡으로 인한 불법적인 공격 또는 기밀정보 유출",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 97,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-07",
            "threat_type": "T",
            "threat_nm": "환경설정의 미흡 비인가자 접근",
            "threat_desc": "시스템환경 설정의 미흡으로 비인가자에 의한 불법적인 시스템 환경 수정 발생",
            "strength_grd": "M",
            "frequency_grd": "M",
            "intensity_score": 2,
            "frequency_score": 2,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 98,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-08",
            "threat_type": "T",
            "threat_nm": "불필요한 서비스 제공 비인가자 접근",
            "threat_desc": "불필요한 서비스 제공 및 통제미흡으로(웹취약점 통제 포함) 보안취약 서비스를 이용한 불법적인 침해시도를 통한 내부정보 유출(예:고객 개인정보 등)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 99,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-09",
            "threat_type": "T",
            "threat_nm": "응용시스템 취약 및 신규 취약점으로 인한 비인가자 접근",
            "threat_desc": "응용시스템 또는 응용이 이용하는 서비스나 프로그래밍 방식이 취약하거나 새로운 취약성이 발견되어 허가되지 않은 자의 접근가능",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 100,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-10",
            "threat_type": "T",
            "threat_nm": "원격관리 미흡으로 비인가자 접근",
            "threat_desc": "네트워크 접근통제 미흡으로 원격 관리 기능을 통해 허가받지 않은 자가 네트워크에 접근할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 101,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-11",
            "threat_type": "T",
            "threat_nm": "로그분석 및 보관 부재",
            "threat_desc": "로그를 분석하거나 보관하지 않아 보안 위반의 발생 여부나 책임자 확인이 불가능 할 수 있음",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 102,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-12",
            "threat_type": "T",
            "threat_nm": "정보의 무결성 손실",
            "threat_desc": "전자정보(데이터, 전자문서 등)에 대한 비인가자에 의한 임의적 변경 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 103,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-13",
            "threat_type": "T",
            "threat_nm": "악성소프트웨어 공격",
            "threat_desc": "웜 및 바이러스에 의한 정보시스템 장애 및 정보유출 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 104,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TT-14",
            "threat_type": "T",
            "threat_nm": "해킹발생",
            "threat_desc": "해커, 크래커, 컴퓨터범죄자, 산업스파이, 정부지원 스파이 등에 의한 정보시스템 장애 및 정보유출 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 105,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-01",
            "threat_type": "M",
            "threat_nm": "보안규정",
            "threat_desc": "보안 정책/지침/절차의 부적정성, 보안규정 미준수로 인한 보안사고의 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 106,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-02",
            "threat_type": "M",
            "threat_nm": "보안조직",
            "threat_desc": "보안조직의 인원 및 역량 부족으로 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 107,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-03",
            "threat_type": "M",
            "threat_nm": "자산관리",
            "threat_desc": "자산의 중요도 및 특성이 분류되지 않아 통제가 부족하거나 과도한 통제로 비용과 노력이 낭비\n(노트북 등 이동 컴퓨팅 장비에 대한 통제부족으로 장비가 이동 중 분실, 도난, 손상 등이 발생 할 수 있음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 108,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-04",
            "threat_type": "M",
            "threat_nm": "외부직원 계약",
            "threat_desc": "위탁회사와의 계약 시 보안요구사항을 명시하지 않아 위탁 운영되는 자산에 대한 보안이 필요 수준에 미흡할 수 있음\n(중요한 시스템을 운영하는 인력에 대한 신원조회, 전문성 등의 검증이 이루어지지 않을 수 있음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 109,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-05",
            "threat_type": "M",
            "threat_nm": "외부직원",
            "threat_desc": " 외부자(용역,아웃소싱 등)에 의한 권한 내 데이터 유출, 변조 및 파괴",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 110,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-06",
            "threat_type": "M",
            "threat_nm": "전문성 및 전담 인력",
            "threat_desc": "인력의 전문성 및 전담 인력의 부족하거나 과도한 통제로 비용과 노력이 낭비 될 수 있음",
            "strength_grd": "M",
            "frequency_grd": "M",
            "intensity_score": 2,
            "frequency_score": 2,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 111,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-07",
            "threat_type": "M",
            "threat_nm": "교육 및 훈련",
            "threat_desc": "임직원 및 외주업체직원의 보안인식 및 업무기능과 관련된 교육 및 훈련 부족으로 보안사고 발생\n(위탁회사의 정보보호대책이 부족하거나 인력의 보안의식 부재로 인해 자산이 보호되지 않음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 112,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-08",
            "threat_type": "M",
            "threat_nm": "내부직원",
            "threat_desc": "내부자에 의한 권한 내 데이터 유출, 변조 및 파괴\n(중요 직무가 분류되지 않아 통제가 부족하거나 과도한 통제로 비용과 노력이 낭비 될 수 있음)",
            "strength_grd": "H",
            "frequency_grd": "M",
            "intensity_score": 3,
            "frequency_score": 2,
            "threat_score": 5,
            "threat_grd": "H",
            "threat_grd_score": 5,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 113,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-09",
            "threat_type": "M",
            "threat_nm": "운영실수",
            "threat_desc": "내부전산운영요원, 외부유지보수인력, 사용자, 직원의 실수, 부주의에 의한 보안사고 발생\n(보안시스템의 운영 관리에 대한 통제 부족으로 허가되지 않은 보안 통제의 변경이 발생할 있음)",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 114,
            "report_id": "CM001_WE_2023_0003",
            "threat_cd": "TM-10",
            "threat_type": "M",
            "threat_nm": "운영절차",
            "threat_desc": "운영절차의 문서화 미비 및 오류로 인한 보안사고 발생",
            "strength_grd": "H",
            "frequency_grd": "L",
            "intensity_score": 3,
            "frequency_score": 1,
            "threat_score": 4,
            "threat_grd": "M",
            "threat_grd_score": 4,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        }
    ]


    export const resultListData = [
        {
            "id": 1,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX1",
            "asset_cd": "US01",
            "measure_cd": "LX1-01",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 2,
            "sum_score": 2,
            "avg_score": 2,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 2,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX1",
            "asset_cd": "US02",
            "measure_cd": "LX1-02",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 1,
            "sum_score": 3,
            "avg_score": 2,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 3,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX1",
            "asset_cd": "US03",
            "measure_cd": "LX1-03",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 2,
            "sum_score": 3,
            "avg_score": 2,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 4,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX1",
            "asset_cd": "US04",
            "measure_cd": "LX1-04",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 2,
            "sum_score": 2,
            "avg_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 5,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX1",
            "asset_cd": "US05",
            "measure_cd": "LX1-05",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 2,
            "sum_score": 2,
            "avg_score": 2,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 6,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX1",
            "asset_cd": "US06",
            "measure_cd": "LX1-06",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 1,
            "sum_score": 1,
            "avg_score": 1,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 7,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX2",
            "asset_cd": "US07",
            "measure_cd": "LX2-01",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 2,
            "sum_score": 2,
            "avg_score": 2,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 8,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX2",
            "asset_cd": "US08",
            "measure_cd": "LX2-02",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 3,
            "sum_score": 3,
            "avg_score": 3,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 9,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX2",
            "asset_cd": "US09",
            "measure_cd": "LX2-03",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 2,
            "sum_score": 2,
            "avg_score": 2,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
        {
            "id": 10,
            "report_id": "CM001_US_2023_0001",
            "result_type": "LX2",
            "asset_cd": "US10",
            "measure_cd": "LX2-04",
            "result_cd": "",
            "result_desc": "",
            "risk_score": 2,
            "sum_score": 1,
            "avg_score": 1,
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null
        },
    ]


export const reportListData = [
    {
        "id": 1,
        "report_id": "CM001_US_2023_0001",
        "type": "LS1",
        "type_nm": "계정관리",
        "item_cnt": 78,
        "check_cnt": 78,
        "y_cnt": 39,
        "n_cnt": 39,
        "p_cnt": 0,
        "x_cnt": 0,
        "sum_score": 169,
        "avg_score": 91,
        "level": 53.8,
        "level_avg" : 69.2
    },
    {
        "id": 2,
        "report_id": "CM001_US_2023_0001",
        "type": "LS2",
        "type_nm": "접근통제",
        "item_cnt": 91,
        "check_cnt": 91,
        "y_cnt": 78,
        "n_cnt": 13,
        "p_cnt": 0,
        "x_cnt": 0,
        "sum_score": 208,
        "avg_score": 169,
        "level": 81.3,
        "level_avg" : 69.2
    },
    {
        "id": 3,
        "report_id": "CM001_US_2023_0001",
        "type": "LS3",
        "type_nm": "시스템환경설정",
        "item_cnt": 26,
        "check_cnt": 26,
        "y_cnt": 13,
        "n_cnt": 13,
        "p_cnt": 0,
        "x_cnt": 0,
        "sum_score": 39,
        "avg_score": 26,
        "level": 66.7,
        "level_avg" : 69.2
    },
    {
        "id": 4,
        "report_id": "CM001_US_2023_0001",
        "type": "LS4",
        "type_nm": "네트워크서비스",
        "item_cnt": 104,
        "check_cnt": 104,
        "y_cnt": 78,
        "n_cnt": 26,
        "p_cnt": 0,
        "x_cnt": 0,
        "sum_score": 182,
        "avg_score": 143,
        "level": 78.6,
        "level_avg" : 69.2
    },
    {
        "id": 5,
        "report_id": "CM001_US_2023_0001",
        "type": "LS5",
        "type_nm": "감사및로그관리",
        "item_cnt": 26,
        "check_cnt": 26,
        "y_cnt": 0,
        "n_cnt": 26,
        "p_cnt": 0,
        "x_cnt": 0,
        "sum_score": 39,
        "avg_score": 0,
        "level": 0.0,
        "level_avg" : 69.2
    },
    {
        "id": 6,
        "report_id": "CM001_US_2023_0001",
        "type": "LS6",
        "type_nm": "패치관리",
        "item_cnt": 13,
        "check_cnt": 13,
        "y_cnt": 13,
        "n_cnt": 0,
        "p_cnt": 0,
        "x_cnt": 0,
        "sum_score": 39,
        "avg_score": 39,
        "level": 100.0,
        "level_avg" : 69.2
    },
]

export const reportChartData = [
    { year: 2010, count: 10 },
    { year: 2011, count: 20 },
    { year: 2012, count: 15 },
    { year: 2013, count: 25 },
    { year: 2014, count: 22 },
    { year: 2015, count: 30 },
    { year: 2016, count: 28 },
  ];

  export const vulnerablityReportData = {
    "statistic_root": [
        {
            "id": 1,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX1-01",
            "measure_type": "LX1\n계정 관리",
            "measure_nm": "root 이외에 UID/GID가 0인 사용자 존재여부",
            "important_grd": "M",
            "risk_cd": "R-LX1-01",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-06",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 2,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX1-02",
            "measure_type": "LX1\n계정 관리",
            "measure_nm": "불필요한 계정 제거",
            "important_grd": "M",
            "risk_cd": "R-LX1-02",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-08",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "N",
            "__LX02": "N",
            "__LX03": "N",
            "__LX04": "N",
            "__LX05": "N",
            "__LX06": "N",
            "__LX07": "N",
            "__LX08": "N",
            "__LX09": "N",
            "__LX10": "N",
            "__LX11": "N",
            "__LX12": "N",
            "__LX13": "N",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 0,
            "stat_measure_Yed": 0,
            "stat_measure_N": 13,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 0
        },
        {
            "id": 3,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX1-03",
            "measure_type": "LX1\n계정 관리",
            "measure_nm": "불필요하게 쉘(shell)이 부여된 계정 존재여부",
            "important_grd": "M",
            "risk_cd": "R-LX1-03",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-07",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 4,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX1-04",
            "measure_type": "LX1\n계정 관리",
            "measure_nm": "패스워드 정책 설정",
            "important_grd": "M",
            "risk_cd": "R-LX1-04",
            "cost_measure": 5,
            "risk_measure": 4,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-06",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "N",
            "__LX02": "N",
            "__LX03": "N",
            "__LX04": "N",
            "__LX05": "N",
            "__LX06": "N",
            "__LX07": "N",
            "__LX08": "N",
            "__LX09": "N",
            "__LX10": "N",
            "__LX11": "N",
            "__LX12": "N",
            "__LX13": "N",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 0,
            "stat_measure_Yed": 0,
            "stat_measure_N": 13,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 0
        },
        {
            "id": 5,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX1-05",
            "measure_type": "LX1\n계정 관리",
            "measure_nm": "일반 사용자의 SU 명령 제한",
            "important_grd": "M",
            "risk_cd": "R-LX1-05",
            "cost_measure": 5,
            "risk_measure": 4,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-07",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "N",
            "__LX02": "N",
            "__LX03": "N",
            "__LX04": "N",
            "__LX05": "N",
            "__LX06": "N",
            "__LX07": "N",
            "__LX08": "N",
            "__LX09": "N",
            "__LX10": "N",
            "__LX11": "N",
            "__LX12": "N",
            "__LX13": "N",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 0,
            "stat_measure_Yed": 0,
            "stat_measure_N": 13,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 0
        },
        {
            "id": 6,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX1-06",
            "measure_type": "LX1\n계정 관리",
            "measure_nm": "취약한 패스워드 사용 여부",
            "important_grd": "H",
            "risk_cd": "R-LX1-06",
            "cost_measure": 5,
            "risk_measure": 5,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-06",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 39,
            "stat_eval_score": 39
        },
        {
            "id": 7,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX2-01",
            "measure_type": "LX2\n접근 통제",
            "measure_nm": "계정 관련 파일 접근권한 설정",
            "important_grd": "H",
            "risk_cd": "R-LX2-01",
            "cost_measure": 5,
            "risk_measure": 4,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-12",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "N",
            "__LX02": "N",
            "__LX03": "N",
            "__LX04": "N",
            "__LX05": "N",
            "__LX06": "N",
            "__LX07": "N",
            "__LX08": "N",
            "__LX09": "N",
            "__LX10": "N",
            "__LX11": "N",
            "__LX12": "N",
            "__LX13": "N",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 0,
            "stat_measure_Yed": 0,
            "stat_measure_N": 13,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 39,
            "stat_eval_score": 0
        },
        {
            "id": 8,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX2-02",
            "measure_type": "LX2\n접근 통제",
            "measure_nm": "주요 디렉터리 접근권한 설정",
            "important_grd": "H",
            "risk_cd": "R-LX2-02",
            "cost_measure": 5,
            "risk_measure": 4,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-12",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 39,
            "stat_eval_score": 39
        },
        {
            "id": 9,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX2-03",
            "measure_type": "LX2\n접근 통제",
            "measure_nm": "네트워크 서비스 설정 파일 접근권한 설정",
            "important_grd": "M",
            "risk_cd": "R-LX2-03",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-12",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 10,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX2-04",
            "measure_type": "LX2\n접근 통제",
            "measure_nm": "원격에서 root로 로그인 가능하지 않게 설정",
            "important_grd": "M",
            "risk_cd": "R-LX2-04",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-12",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 11,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX2-05",
            "measure_type": "LX2\n접근 통제",
            "measure_nm": "R 서비스 설정파일 접근권한 설정",
            "important_grd": "M",
            "risk_cd": "R-LX2-05",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-12",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 12,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX2-06",
            "measure_type": "LX2\n접근 통제",
            "measure_nm": "syslog.conf 파일 접근권한 설정",
            "important_grd": "M",
            "risk_cd": "R-LX2-06",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-12",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 13,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX2-07",
            "measure_type": "LX2\n접근 통제",
            "measure_nm": "로그파일 접근권한 설정",
            "important_grd": "M",
            "risk_cd": "R-LX2-07",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-12",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 14,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX3-01",
            "measure_type": "LX3\n시스템 환경설정",
            "measure_nm": "UMASK 설정",
            "important_grd": "L",
            "risk_cd": "R-LX3-01",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-07",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "N",
            "__LX02": "N",
            "__LX03": "N",
            "__LX04": "N",
            "__LX05": "N",
            "__LX06": "N",
            "__LX07": "N",
            "__LX08": "N",
            "__LX09": "N",
            "__LX10": "N",
            "__LX11": "N",
            "__LX12": "N",
            "__LX13": "N",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 0,
            "stat_measure_Yed": 0,
            "stat_measure_N": 13,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 13,
            "stat_eval_score": 0
        },
        {
            "id": 15,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX3-02",
            "measure_type": "LX3\n시스템 환경설정",
            "measure_nm": "PATH 설정",
            "important_grd": "M",
            "risk_cd": "R-LX3-02",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-07",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 16,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX4-01",
            "measure_type": "LX4\n네트워크 서비스",
            "measure_nm": "서비스 배너에 시스템 정보 제공 여부",
            "important_grd": "L",
            "risk_cd": "R-LX4-01",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-07",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "N",
            "__LX02": "N",
            "__LX03": "N",
            "__LX04": "N",
            "__LX05": "N",
            "__LX06": "N",
            "__LX07": "N",
            "__LX08": "N",
            "__LX09": "N",
            "__LX10": "N",
            "__LX11": "N",
            "__LX12": "N",
            "__LX13": "N",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 0,
            "stat_measure_Yed": 0,
            "stat_measure_N": 13,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 13,
            "stat_eval_score": 0
        },
        {
            "id": 17,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX4-02",
            "measure_type": "LX4\n네트워크 서비스",
            "measure_nm": "불필요한 RPC 서비스 중지",
            "important_grd": "M",
            "risk_cd": "R-LX4-02",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-08",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 18,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX4-03",
            "measure_type": "LX4\n네트워크 서비스",
            "measure_nm": "불필요한 R 서비스(1) 구동 중지",
            "important_grd": "M",
            "risk_cd": "R-LX4-03",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-08",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 19,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX4-04",
            "measure_type": "LX4\n네트워크 서비스",
            "measure_nm": "불필요한 R 서비스(2) 신뢰관계설정",
            "important_grd": "M",
            "risk_cd": "R-LX4-04",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-08",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 20,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX4-05",
            "measure_type": "LX4\n네트워크 서비스",
            "measure_nm": "익명 FTP(Anonymous FTP) 사용 여부",
            "important_grd": "L",
            "risk_cd": "R-LX4-05",
            "cost_measure": 5,
            "risk_measure": 4,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-07",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 13,
            "stat_eval_score": 13
        },
        {
            "id": 21,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX4-06",
            "measure_type": "LX4\n네트워크 서비스",
            "measure_nm": "Telnet의 root 계정 로그인 제한",
            "important_grd": "M",
            "risk_cd": "R-LX4-06",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-10",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "N",
            "__LX02": "N",
            "__LX03": "N",
            "__LX04": "N",
            "__LX05": "N",
            "__LX06": "N",
            "__LX07": "N",
            "__LX08": "N",
            "__LX09": "N",
            "__LX10": "N",
            "__LX11": "N",
            "__LX12": "N",
            "__LX13": "N",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 0,
            "stat_measure_Yed": 0,
            "stat_measure_N": 13,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 0
        },
        {
            "id": 22,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX4-07",
            "measure_type": "LX4\n네트워크 서비스",
            "measure_nm": "SNMP - Community String 설정",
            "important_grd": "M",
            "risk_cd": "R-LX4-07",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-07",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 23,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX4-08",
            "measure_type": "LX4\n네트워크 서비스",
            "measure_nm": "불필요한 서비스 중지",
            "important_grd": "M",
            "risk_cd": "R-LX4-08",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-08",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 26
        },
        {
            "id": 24,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX5-01",
            "measure_type": "LX5\n감사 및 로그관리",
            "measure_nm": "SU 로그 기록",
            "important_grd": "L",
            "risk_cd": "R-LX5-01",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-11",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "N",
            "__LX02": "N",
            "__LX03": "N",
            "__LX04": "N",
            "__LX05": "N",
            "__LX06": "N",
            "__LX07": "N",
            "__LX08": "N",
            "__LX09": "N",
            "__LX10": "N",
            "__LX11": "N",
            "__LX12": "N",
            "__LX13": "N",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 0,
            "stat_measure_Yed": 0,
            "stat_measure_N": 13,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 13,
            "stat_eval_score": 0
        },
        {
            "id": 25,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX5-02",
            "measure_type": "LX5\n감사 및 로그관리",
            "measure_nm": "syslog 설정",
            "important_grd": "M",
            "risk_cd": "R-LX5-02",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 5,
            "apply_time": "단기",
            "apply_action": "위험감소",
            "threat_cd": "TT-11",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "N",
            "__LX02": "N",
            "__LX03": "N",
            "__LX04": "N",
            "__LX05": "N",
            "__LX06": "N",
            "__LX07": "N",
            "__LX08": "N",
            "__LX09": "N",
            "__LX10": "N",
            "__LX11": "N",
            "__LX12": "N",
            "__LX13": "N",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 0,
            "stat_measure_Yed": 0,
            "stat_measure_N": 13,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 26,
            "stat_eval_score": 0
        },
        {
            "id": 26,
            "report_id": "CM001_LX_2023_0001",
            "measure_cd": "LX6-01",
            "measure_type": "LX6\n패치 관리",
            "measure_nm": "최신 시스템 패치 적용",
            "important_grd": "H",
            "risk_cd": "R-LX6-01",
            "cost_measure": 5,
            "risk_measure": 3,
            "difficulty_measure": 3,
            "apply_time": "중기",
            "apply_action": "위험감소",
            "threat_cd": "TT-09",
            "sys_reg_user": null,
            "sys_reg_date": null,
            "sys_mod_user": null,
            "sys_mod_date": null,
            "__LX01": "Y",
            "__LX02": "Y",
            "__LX03": "Y",
            "__LX04": "Y",
            "__LX05": "Y",
            "__LX06": "Y",
            "__LX07": "Y",
            "__LX08": "Y",
            "__LX09": "Y",
            "__LX10": "Y",
            "__LX11": "Y",
            "__LX12": "Y",
            "__LX13": "Y",
            "stat_measure_total": 13,
            "stat_measure_check": 13,
            "stat_measure_Y": 13,
            "stat_measure_Yed": 0,
            "stat_measure_N": 0,
            "stat_measure_P": 0,
            "stat_measure_NA": 0,
            "stat_total_score": 39,
            "stat_eval_score": 39
        }
    ],
    "statistic_measure": [
        {
            "code": "LX1",
            "name": "계정 관리",
            "total": 78,
            "Y": 39,
            "Yed": 0,
            "N": 39,
            "P": 0,
            "NA": 0,
            "total_score": 169,
            "eval_score": 91,
            "level": 53.8,
            "check": 78
        },
        {
            "code": "LX2",
            "name": "접근 통제",
            "total": 91,
            "Y": 78,
            "Yed": 0,
            "N": 13,
            "P": 0,
            "NA": 0,
            "total_score": 208,
            "eval_score": 169,
            "level": 81.2,
            "check": 91
        },
        {
            "code": "LX3",
            "name": "시스템 환경설정",
            "total": 26,
            "Y": 13,
            "Yed": 0,
            "N": 13,
            "P": 0,
            "NA": 0,
            "total_score": 39,
            "eval_score": 26,
            "level": 66.7,
            "check": 26
        },
        {
            "code": "LX4",
            "name": "네트워크 서비스",
            "total": 104,
            "Y": 78,
            "Yed": 0,
            "N": 26,
            "P": 0,
            "NA": 0,
            "total_score": 182,
            "eval_score": 143,
            "level": 78.6,
            "check": 104
        },
        {
            "code": "LX5",
            "name": "감사 및 로그관리",
            "total": 26,
            "Y": 0,
            "Yed": 0,
            "N": 26,
            "P": 0,
            "NA": 0,
            "total_score": 39,
            "eval_score": 0,
            "level": 0.0,
            "check": 26
        },
        {
            "code": "LX6",
            "name": "패치 관리",
            "total": 13,
            "Y": 13,
            "Yed": 0,
            "N": 0,
            "P": 0,
            "NA": 0,
            "total_score": 39,
            "eval_score": 39,
            "level": 100.0,
            "check": 13
        }
    ],
    "statistic_asset": [
        {
            "code": "LX01",
            "name": "ip-10-0-0-250",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX02",
            "name": "ip-10-0-10-210",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX03",
            "name": "ip-10-0-11-160",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX04",
            "name": "ip-10-0-10-69",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX05",
            "name": "ip-10-0-11-215",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX06",
            "name": "ip-10-0-10-248",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX07",
            "name": "ip-10-0-11-189",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX08",
            "name": "ip-10-0-10-193",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX09",
            "name": "ip-10-0-11-50",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX10",
            "name": "ip-10-0-10-35",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX11",
            "name": "ip-10-0-11-86",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX12",
            "name": "ip-10-0-10-11",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        },
        {
            "code": "LX13",
            "name": "ip-10-0-10-24",
            "total": 26,
            "Y": 17,
            "Yed": 0,
            "N": 9,
            "P": 0,
            "NA": 0,
            "total_score": 52,
            "eval_score": 36,
            "check": 26,
            "level": 69.2
        }
    ]
};


    export const riskReportData = {
        "statistic_root": [
            {
                "id": 1,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-01",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "root 이외에 UID/GID가 0인 사용자 존재여부",
                "important_grd": "M",
                "risk_cd": "R-LX1-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 2,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-02",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "불필요한 계정 제거",
                "important_grd": "M",
                "risk_cd": "R-LX1-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 12,
                "__LX02": 12,
                "__LX03": 12,
                "__LX04": 12,
                "__LX05": 12,
                "__LX06": 12,
                "__LX07": 12,
                "__LX08": 12,
                "__LX09": 12,
                "__LX10": 12,
                "__LX11": 12,
                "__LX12": 12,
                "__LX13": 12,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 13,
                "stat_measure_H": 13,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 0,
                "stat_measure_NA": 0
            },
            {
                "id": 3,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-03",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "불필요하게 쉘(shell)이 부여된 계정 존재여부",
                "important_grd": "M",
                "risk_cd": "R-LX1-03",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 4,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-04",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "패스워드 정책 설정",
                "important_grd": "M",
                "risk_cd": "R-LX1-04",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 12,
                "__LX02": 12,
                "__LX03": 12,
                "__LX04": 12,
                "__LX05": 12,
                "__LX06": 12,
                "__LX07": 12,
                "__LX08": 12,
                "__LX09": 12,
                "__LX10": 12,
                "__LX11": 12,
                "__LX12": 12,
                "__LX13": 12,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 13,
                "stat_measure_H": 13,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 0,
                "stat_measure_NA": 0
            },
            {
                "id": 5,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-05",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "일반 사용자의 SU 명령 제한",
                "important_grd": "M",
                "risk_cd": "R-LX1-05",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 8,
                "__LX02": 8,
                "__LX03": 8,
                "__LX04": 8,
                "__LX05": 8,
                "__LX06": 8,
                "__LX07": 8,
                "__LX08": 8,
                "__LX09": 8,
                "__LX10": 8,
                "__LX11": 8,
                "__LX12": 8,
                "__LX13": 8,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 13,
                "stat_measure_H": 0,
                "stat_measure_M": 13,
                "stat_measure_L": 0,
                "stat_measure_Zero": 0,
                "stat_measure_NA": 0
            },
            {
                "id": 6,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-06",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "취약한 패스워드 사용 여부",
                "important_grd": "H",
                "risk_cd": "R-LX1-06",
                "cost_measure": 5,
                "risk_measure": 5,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 7,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-01",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "계정 관련 파일 접근권한 설정",
                "important_grd": "H",
                "risk_cd": "R-LX2-01",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 18,
                "__LX02": 18,
                "__LX03": 18,
                "__LX04": 18,
                "__LX05": 18,
                "__LX06": 18,
                "__LX07": 18,
                "__LX08": 18,
                "__LX09": 18,
                "__LX10": 18,
                "__LX11": 18,
                "__LX12": 18,
                "__LX13": 18,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 13,
                "stat_measure_H": 13,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 0,
                "stat_measure_NA": 0
            },
            {
                "id": 8,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-02",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "주요 디렉터리 접근권한 설정",
                "important_grd": "H",
                "risk_cd": "R-LX2-02",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 9,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-03",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "네트워크 서비스 설정 파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-03",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 10,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-04",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "원격에서 root로 로그인 가능하지 않게 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-04",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 11,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-05",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "R 서비스 설정파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-05",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 12,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-06",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "syslog.conf 파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-06",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 13,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-07",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "로그파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-07",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 14,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX3-01",
                "measure_type": "LX3\n시스템 환경설정",
                "measure_nm": "UMASK 설정",
                "important_grd": "L",
                "risk_cd": "R-LX3-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 4,
                "__LX02": 4,
                "__LX03": 4,
                "__LX04": 4,
                "__LX05": 4,
                "__LX06": 4,
                "__LX07": 4,
                "__LX08": 4,
                "__LX09": 4,
                "__LX10": 4,
                "__LX11": 4,
                "__LX12": 4,
                "__LX13": 4,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 13,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 13,
                "stat_measure_Zero": 0,
                "stat_measure_NA": 0
            },
            {
                "id": 15,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX3-02",
                "measure_type": "LX3\n시스템 환경설정",
                "measure_nm": "PATH 설정",
                "important_grd": "M",
                "risk_cd": "R-LX3-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 16,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-01",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "서비스 배너에 시스템 정보 제공 여부",
                "important_grd": "L",
                "risk_cd": "R-LX4-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 4,
                "__LX02": 4,
                "__LX03": 4,
                "__LX04": 4,
                "__LX05": 4,
                "__LX06": 4,
                "__LX07": 4,
                "__LX08": 4,
                "__LX09": 4,
                "__LX10": 4,
                "__LX11": 4,
                "__LX12": 4,
                "__LX13": 4,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 13,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 13,
                "stat_measure_Zero": 0,
                "stat_measure_NA": 0
            },
            {
                "id": 17,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-02",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 RPC 서비스 중지",
                "important_grd": "M",
                "risk_cd": "R-LX4-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 18,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-03",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 R 서비스(1) 구동 중지",
                "important_grd": "M",
                "risk_cd": "R-LX4-03",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 19,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-04",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 R 서비스(2) 신뢰관계설정",
                "important_grd": "M",
                "risk_cd": "R-LX4-04",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 20,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-05",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "익명 FTP(Anonymous FTP) 사용 여부",
                "important_grd": "L",
                "risk_cd": "R-LX4-05",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 21,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-06",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "Telnet의 root 계정 로그인 제한",
                "important_grd": "M",
                "risk_cd": "R-LX4-06",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-10",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 12,
                "__LX02": 12,
                "__LX03": 12,
                "__LX04": 12,
                "__LX05": 12,
                "__LX06": 12,
                "__LX07": 12,
                "__LX08": 12,
                "__LX09": 12,
                "__LX10": 12,
                "__LX11": 12,
                "__LX12": 12,
                "__LX13": 12,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 13,
                "stat_measure_H": 13,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 0,
                "stat_measure_NA": 0
            },
            {
                "id": 22,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-07",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "SNMP - Community String 설정",
                "important_grd": "M",
                "risk_cd": "R-LX4-07",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 23,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-08",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 서비스 중지",
                "important_grd": "M",
                "risk_cd": "R-LX4-08",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            },
            {
                "id": 24,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX5-01",
                "measure_type": "LX5\n감사 및 로그관리",
                "measure_nm": "SU 로그 기록",
                "important_grd": "L",
                "risk_cd": "R-LX5-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-11",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 6,
                "__LX02": 6,
                "__LX03": 6,
                "__LX04": 6,
                "__LX05": 6,
                "__LX06": 6,
                "__LX07": 6,
                "__LX08": 6,
                "__LX09": 6,
                "__LX10": 6,
                "__LX11": 6,
                "__LX12": 6,
                "__LX13": 6,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 13,
                "stat_measure_H": 0,
                "stat_measure_M": 13,
                "stat_measure_L": 0,
                "stat_measure_Zero": 0,
                "stat_measure_NA": 0
            },
            {
                "id": 25,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX5-02",
                "measure_type": "LX5\n감사 및 로그관리",
                "measure_nm": "syslog 설정",
                "important_grd": "M",
                "risk_cd": "R-LX5-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-11",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 12,
                "__LX02": 12,
                "__LX03": 12,
                "__LX04": 12,
                "__LX05": 12,
                "__LX06": 12,
                "__LX07": 12,
                "__LX08": 12,
                "__LX09": 12,
                "__LX10": 12,
                "__LX11": 12,
                "__LX12": 12,
                "__LX13": 12,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 13,
                "stat_measure_H": 13,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 0,
                "stat_measure_NA": 0
            },
            {
                "id": 26,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX6-01",
                "measure_type": "LX6\n패치 관리",
                "measure_nm": "최신 시스템 패치 적용",
                "important_grd": "H",
                "risk_cd": "R-LX6-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 3,
                "apply_time": "중기",
                "apply_action": "위험감소",
                "threat_cd": "TT-09",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0,
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_total_risk": 0,
                "stat_measure_H": 0,
                "stat_measure_M": 0,
                "stat_measure_L": 0,
                "stat_measure_Zero": 13,
                "stat_measure_NA": 0
            }
        ],
        "statistic_measure": [
            {
                "code": "LX1",
                "name": "계정 관리",
                "total": 78,
                "total_risk": 39,
                "H": 26,
                "M": 13,
                "L": 0,
                "NA": 0,
                "Zero": 39,
                "ManagedRisks": 66.7,
                "UnmanagedRisks": 33.3,
                "check": 78
            },
            {
                "code": "LX2",
                "name": "접근 통제",
                "total": 91,
                "total_risk": 13,
                "H": 13,
                "M": 0,
                "L": 0,
                "NA": 0,
                "Zero": 78,
                "ManagedRisks": 100.0,
                "UnmanagedRisks": 0.0,
                "check": 91
            },
            {
                "code": "LX3",
                "name": "시스템 환경설정",
                "total": 26,
                "total_risk": 13,
                "H": 0,
                "M": 0,
                "L": 13,
                "NA": 0,
                "Zero": 13,
                "ManagedRisks": 0.0,
                "UnmanagedRisks": 100.0,
                "check": 26
            },
            {
                "code": "LX4",
                "name": "네트워크 서비스",
                "total": 104,
                "total_risk": 26,
                "H": 13,
                "M": 0,
                "L": 13,
                "NA": 0,
                "Zero": 78,
                "ManagedRisks": 50.0,
                "UnmanagedRisks": 50.0,
                "check": 104
            },
            {
                "code": "LX5",
                "name": "감사 및 로그관리",
                "total": 26,
                "total_risk": 26,
                "H": 13,
                "M": 13,
                "L": 0,
                "NA": 0,
                "Zero": 0,
                "ManagedRisks": 50.0,
                "UnmanagedRisks": 50.0,
                "check": 26
            },
            {
                "code": "LX6",
                "name": "패치 관리",
                "total": 13,
                "total_risk": 0,
                "H": 0,
                "M": 0,
                "L": 0,
                "NA": 0,
                "Zero": 13,
                "ManagedRisks": 0.0,
                "UnmanagedRisks": 100.0,
                "check": 13
            }
        ],
        "statistic_risk_score": [
            {
                "risk_score": "위험도0",
                "sum": 221,
                "__LX01": 17,
                "__LX02": 17,
                "__LX03": 17,
                "__LX04": 17,
                "__LX05": 17,
                "__LX06": 17,
                "__LX07": 17,
                "__LX08": 17,
                "__LX09": 17,
                "__LX10": 17,
                "__LX11": 17,
                "__LX12": 17,
                "__LX13": 17
            },
            {
                "risk_score": "위험도1",
                "sum": 0,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0
            },
            {
                "risk_score": "위험도2",
                "sum": 0,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0
            },
            {
                "risk_score": "위험도3",
                "sum": 0,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0
            },
            {
                "risk_score": "위험도4",
                "sum": 26,
                "__LX01": 2,
                "__LX02": 2,
                "__LX03": 2,
                "__LX04": 2,
                "__LX05": 2,
                "__LX06": 2,
                "__LX07": 2,
                "__LX08": 2,
                "__LX09": 2,
                "__LX10": 2,
                "__LX11": 2,
                "__LX12": 2,
                "__LX13": 2
            },
            {
                "risk_score": "위험도6",
                "sum": 13,
                "__LX01": 1,
                "__LX02": 1,
                "__LX03": 1,
                "__LX04": 1,
                "__LX05": 1,
                "__LX06": 1,
                "__LX07": 1,
                "__LX08": 1,
                "__LX09": 1,
                "__LX10": 1,
                "__LX11": 1,
                "__LX12": 1,
                "__LX13": 1
            },
            {
                "risk_score": "위험도8",
                "sum": 13,
                "__LX01": 1,
                "__LX02": 1,
                "__LX03": 1,
                "__LX04": 1,
                "__LX05": 1,
                "__LX06": 1,
                "__LX07": 1,
                "__LX08": 1,
                "__LX09": 1,
                "__LX10": 1,
                "__LX11": 1,
                "__LX12": 1,
                "__LX13": 1
            },
            {
                "risk_score": "위험도9",
                "sum": 0,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0
            },
            {
                "risk_score": "위험도12",
                "sum": 52,
                "__LX01": 4,
                "__LX02": 4,
                "__LX03": 4,
                "__LX04": 4,
                "__LX05": 4,
                "__LX06": 4,
                "__LX07": 4,
                "__LX08": 4,
                "__LX09": 4,
                "__LX10": 4,
                "__LX11": 4,
                "__LX12": 4,
                "__LX13": 4
            },
            {
                "risk_score": "위험도18",
                "sum": 13,
                "__LX01": 1,
                "__LX02": 1,
                "__LX03": 1,
                "__LX04": 1,
                "__LX05": 1,
                "__LX06": 1,
                "__LX07": 1,
                "__LX08": 1,
                "__LX09": 1,
                "__LX10": 1,
                "__LX11": 1,
                "__LX12": 1,
                "__LX13": 1
            },
            {
                "risk_score": "위험도27",
                "sum": 0,
                "__LX01": 0,
                "__LX02": 0,
                "__LX03": 0,
                "__LX04": 0,
                "__LX05": 0,
                "__LX06": 0,
                "__LX07": 0,
                "__LX08": 0,
                "__LX09": 0,
                "__LX10": 0,
                "__LX11": 0,
                "__LX12": 0,
                "__LX13": 0
            }
        ],
        "statistic_risk_grade": [
            {
                "risk_grade": "H",
                "sum": 65,
                "__LX01": 5,
                "__LX02": 5,
                "__LX03": 5,
                "__LX04": 5,
                "__LX05": 5,
                "__LX06": 5,
                "__LX07": 5,
                "__LX08": 5,
                "__LX09": 5,
                "__LX10": 5,
                "__LX11": 5,
                "__LX12": 5,
                "__LX13": 5
            },
            {
                "risk_grade": "M",
                "sum": 26,
                "__LX01": 2,
                "__LX02": 2,
                "__LX03": 2,
                "__LX04": 2,
                "__LX05": 2,
                "__LX06": 2,
                "__LX07": 2,
                "__LX08": 2,
                "__LX09": 2,
                "__LX10": 2,
                "__LX11": 2,
                "__LX12": 2,
                "__LX13": 2
            },
            {
                "risk_grade": "L",
                "sum": 26,
                "__LX01": 2,
                "__LX02": 2,
                "__LX03": 2,
                "__LX04": 2,
                "__LX05": 2,
                "__LX06": 2,
                "__LX07": 2,
                "__LX08": 2,
                "__LX09": 2,
                "__LX10": 2,
                "__LX11": 2,
                "__LX12": 2,
                "__LX13": 2
            },
            {
                "risk_grade": "전체 위험",
                "sum": 117,
                "__LX01": 9,
                "__LX02": 9,
                "__LX03": 9,
                "__LX04": 9,
                "__LX05": 9,
                "__LX06": 9,
                "__LX07": 9,
                "__LX08": 9,
                "__LX09": 9,
                "__LX10": 9,
                "__LX11": 9,
                "__LX12": 9,
                "__LX13": 9
            }
        ]
    };

    export const assetReportData = {
        "statistic_root": [
            {
                "id": 1,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-01",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "root 이외에 UID/GID가 0인 사용자 존재여부",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 2,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-02",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "불필요한 계정 제거",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 3,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-03",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "불필요하게 쉘(shell)이 부여된 계정 존재여부",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 4,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-04",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "패스워드 정책 설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 5,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-05",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "일반 사용자의 SU 명령 제한",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 6,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-06",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "취약한 패스워드 사용 여부",
                "important_grd": "H",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 7,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-01",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "계정 관련 파일 접근권한 설정",
                "important_grd": "H",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 8,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-02",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "주요 디렉터리 접근권한 설정",
                "important_grd": "H",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 9,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-03",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "네트워크 서비스 설정 파일 접근권한 설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 10,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-04",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "원격에서 root로 로그인 가능하지 않게 설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 11,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-05",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "R 서비스 설정파일 접근권한 설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 12,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-06",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "syslog.conf 파일 접근권한 설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 13,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-07",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "로그파일 접근권한 설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 14,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX3-01",
                "measure_type": "LX3\n시스템 환경설정",
                "measure_nm": "UMASK 설정",
                "important_grd": "L",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 15,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX3-02",
                "measure_type": "LX3\n시스템 환경설정",
                "measure_nm": "PATH 설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 16,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-01",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "서비스 배너에 시스템 정보 제공 여부",
                "important_grd": "L",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 17,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-02",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 RPC 서비스 중지",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 18,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-03",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 R 서비스(1) 구동 중지",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 19,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-04",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 R 서비스(2) 신뢰관계설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 20,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-05",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "익명 FTP(Anonymous FTP) 사용 여부",
                "important_grd": "L",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 21,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-06",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "Telnet의 root 계정 로그인 제한",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 22,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-07",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "SNMP - Community String 설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 23,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-08",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 서비스 중지",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 24,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX5-01",
                "measure_type": "LX5\n감사 및 로그관리",
                "measure_nm": "SU 로그 기록",
                "important_grd": "L",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 25,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX5-02",
                "measure_type": "LX5\n감사 및 로그관리",
                "measure_nm": "syslog 설정",
                "important_grd": "M",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            },
            {
                "id": 26,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX6-01",
                "measure_type": "LX6\n패치 관리",
                "measure_nm": "최신 시스템 패치 적용",
                "important_grd": "H",
                "risk_score": 5,
                "total_score": 3,
                "eval_score": 5,
                "result_desc": "■ 현황☞ UID/GID 정보 root:x:0:0:root:/root:/bin/bash root 이외의 UID가 0인 불필요한 사용자가 존재하지 않음",
                "suggest_desc": "■ 권고사항 오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제",
            }
        ],
        "statistic_measure": [
            {
                "code": "LX1",
                "name": "계정 관리",
                "total": 78,
                "Y": 39,
                "Yed": 0,
                "N": 39,
                "P": 0,
                "NA": 0,
                "total_score": 169,
                "eval_score": 91,
                "level": 53.8,
                "check": 78
            },
            {
                "code": "LX2",
                "name": "접근 통제",
                "total": 91,
                "Y": 78,
                "Yed": 0,
                "N": 13,
                "P": 0,
                "NA": 0,
                "total_score": 208,
                "eval_score": 169,
                "level": 81.2,
                "check": 91
            },
            {
                "code": "LX3",
                "name": "시스템 환경설정",
                "total": 26,
                "Y": 13,
                "Yed": 0,
                "N": 13,
                "P": 0,
                "NA": 0,
                "total_score": 39,
                "eval_score": 26,
                "level": 66.7,
                "check": 26
            },
            {
                "code": "LX4",
                "name": "네트워크 서비스",
                "total": 104,
                "Y": 78,
                "Yed": 0,
                "N": 26,
                "P": 0,
                "NA": 0,
                "total_score": 182,
                "eval_score": 143,
                "level": 78.6,
                "check": 104
            },
            {
                "code": "LX5",
                "name": "감사 및 로그관리",
                "total": 26,
                "Y": 0,
                "Yed": 0,
                "N": 26,
                "P": 0,
                "NA": 0,
                "total_score": 39,
                "eval_score": 0,
                "level": 0.0,
                "check": 26
            },
            {
                "code": "LX6",
                "name": "패치 관리",
                "total": 13,
                "Y": 13,
                "Yed": 0,
                "N": 0,
                "P": 0,
                "NA": 0,
                "total_score": 39,
                "eval_score": 39,
                "level": 100.0,
                "check": 13
            }
        ],
    };
    

    export const riskManagementData = {
        "statistic_root": [
            {
                "id": 2,
                "report_id": "CM001_LX_2023_0001",
                "result_type": "C",
                "asset_cd": "LX01",
                "measure_cd": "LX1-02",
                "result_cd": "N",
                "result_desc": "■ 현황\n☞ 불필요한 계정 목록\nlp:x:7:7:lp:/var/spool/lpd:/usr/sbin/nologin\nuucp:x:10:10:uucp:/var/spool/uucp:/usr/sbin/nologin\n불필요한 계정(lp / uucp / nuucp)이 존재함\n",
                "risk_score": 12,
                "total_score": 2,
                "eval_score": 0,
                "sys_reg_user": "admin",
                "sys_reg_date": "2023-02-02T11:42:21.835289Z",
                "sys_mod_user": "admin",
                "sys_mod_date": "2023-02-02T11:42:21.835289Z",
                "asset_nm": "ip-10-0-0-250",
                "asset_ip": "10.0.0.250",
                "asset_type": "LX",
                "asset_spec": "LINUX",
                "asset_ver": "Ubuntu 20.04.1",
                "os_ver": "-",
                "service_nm": "Bastion 서버(Linux)",
                "location_nm": "AWS Seoul Region",
                "manager_nm": "이재원",
                "supervisor_nm": "이은우",
                "confidential_score": 2,
                "integrity_score": 2,
                "availability_score": 2,
                "asset_grd": "나",
                "asset_rnk": 2,
                "mac_no": "1",
                "measure_type": "LX1",
                "measure_nm": "불필요한 계정 제거",
                "important_grd": "M",
                "risk_cd": "R-LX1-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "suggest_desc": "■ 권고사항\n오랫동안 로그인 하지 않은 계정, 한번도 로그인 하지 않은 계정이 사용되는 계정인지 확인하고 불필요한 계정이면 삭제"
            },
            {
                "id": 4,
                "report_id": "CM001_LX_2023_0001",
                "result_type": "C",
                "asset_cd": "LX01",
                "measure_cd": "LX1-04",
                "result_cd": "N",
                "result_desc": "■ 현황\n☞ 패스워드 최소 길이\n☞ 패스워드 최대 사용 기간\nPASS_MAX_DAYS 99999\n패스워드 최소 길이(8 이상) 및 패스워드 최대 사용 기간(90 이하)이 정책에 맞지 않게 설정되어 있음\n",
                "risk_score": 12,
                "total_score": 2,
                "eval_score": 0,
                "sys_reg_user": "admin",
                "sys_reg_date": "2023-02-02T11:42:21.837289Z",
                "sys_mod_user": "admin",
                "sys_mod_date": "2023-02-02T11:42:21.837289Z",
                "asset_nm": "ip-10-0-0-250",
                "asset_ip": "10.0.0.250",
                "asset_type": "LX",
                "asset_spec": "LINUX",
                "asset_ver": "Ubuntu 20.04.1",
                "os_ver": "-",
                "service_nm": "Bastion 서버(Linux)",
                "location_nm": "AWS Seoul Region",
                "manager_nm": "이재원",
                "supervisor_nm": "이은우",
                "confidential_score": 2,
                "integrity_score": 2,
                "availability_score": 2,
                "asset_grd": "나",
                "asset_rnk": 2,
                "mac_no": "1",
                "measure_type": "LX1",
                "measure_nm": "패스워드 정책 설정",
                "important_grd": "M",
                "risk_cd": "R-LX1-04",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "suggest_desc": "■ 권고사항\n1. 새로 생성할 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/login.defs\nPASS_MIN_LEN 8\n\n2. 새로 생성할 계정에게 적용 - 패스워드 최대 사용기간\n# vi /etc/login.defs\nPASS_MAX_DAYS 90\n\n3. 기존 계정에게 적용 - 패스워드 최소 길이\n# vi /etc/pam.d/system-auth (password-auth도 적용)\npassword    requisite     pam_cracklib.so try_first_pass retry=3 minlen=8\n\n# vi /etc/security/pwquality.conf (7 버전 이상)\nminlen = 8\n\n4. 기존 계정에게 적용 - 패스워드 최대 사용기간\n# chage -M 90 계정명"
            },
        ],
        "statistic_risk_cd": [
            {
                "type": "LX1",
                "code": "R-LX1-01",
                "name": "root 이외에 UID/GID가 0인 사용자 존재여부",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX1",
                "code": "R-LX1-02",
                "name": "불필요한 계정 제거",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "LX1",
                "code": "R-LX1-03",
                "name": "불필요하게 쉘(shell)이 부여된 계정 존재여부",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX1",
                "code": "R-LX1-04",
                "name": "패스워드 정책 설정",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "LX1",
                "code": "R-LX1-05",
                "name": "일반 사용자의 SU 명령 제한",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "LX1",
                "code": "R-LX1-06",
                "name": "취약한 패스워드 사용 여부",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX2",
                "code": "R-LX2-01",
                "name": "계정 관련 파일 접근권한 설정",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "LX2",
                "code": "R-LX2-02",
                "name": "주요 디렉터리 접근권한 설정",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX2",
                "code": "R-LX2-03",
                "name": "네트워크 서비스 설정 파일 접근권한 설정",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX2",
                "code": "R-LX2-04",
                "name": "원격에서 root로 로그인 가능하지 않게 설정",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX2",
                "code": "R-LX2-05",
                "name": "R 서비스 설정파일 접근권한 설정",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX2",
                "code": "R-LX2-06",
                "name": "syslog.conf 파일 접근권한 설정",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX2",
                "code": "R-LX2-07",
                "name": "로그파일 접근권한 설정",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX3",
                "code": "R-LX3-01",
                "name": "UMASK 설정",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                 "type": "LX3",
                "code": "R-LX3-02",
                "name": "PATH 설정",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX3",
                "code": "R-LX4-01",
                "name": "서비스 배너에 시스템 정보 제공 여부",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "LX4",
                "code": "R-LX4-02",
                "name": "불필요한 RPC 서비스 중지",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX4",
                "code": "R-LX4-03",
                "name": "불필요한 R 서비스(1) 구동 중지",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX4",
                "code": "R-LX4-04",
                "name": "불필요한 R 서비스(2) 신뢰관계설정",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX4",
                "code": "R-LX4-05",
                "name": "익명 FTP(Anonymous FTP) 사용 여부",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX4",
                "code": "R-LX4-06",
                "name": "Telnet의 root 계정 로그인 제한",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "LX4",
                "code": "R-LX4-07",
                "name": "SNMP - Community String 설정",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX4",
                "code": "R-LX4-08",
                "name": "불필요한 서비스 중지",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            },
            {
                "type": "LX5",
                "code": "R-LX5-01",
                "name": "SU 로그 기록",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "LX5",
                "code": "R-LX5-02",
                "name": "syslog 설정",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "LX6",
                "code": "R-LX6-01",
                "name": "최신 시스템 패치 적용",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            }
        ],
        "statistic_risk_cd_type": [
            {
                "type": "",
                "code": "LX1",
                "name": "계정 관리",
                "short-term": 39,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 39,
                "risk_acception": 0,
                "total_risk": 39
            },
            {
                "type": "",
                "code": "LX2",
                "name": "접근 통제",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "",
                "code": "LX3",
                "name": "시스템 환경설정",
                "short-term": 13,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 13,
                "risk_acception": 0,
                "total_risk": 13
            },
            {
                "type": "",
                "code": "LX4",
                "name": "네트워크 서비스",
                "short-term": 26,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 26,
                "risk_acception": 0,
                "total_risk": 26
            },
            {
                "type": "",
                "code": "LX5",
                "name": "감사 및 로그관리",
                "short-term": 26,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 26,
                "risk_acception": 0,
                "total_risk": 26
            },
            {
                "type": "",
                "code": "LX6",
                "name": "패치 관리",
                "short-term": 0,
                "mid-to_long-term": 0,
                "Yed": 0,
                "risk_reduction": 0,
                "risk_acception": 0,
                "total_risk": 0
            }
        ]
    };

    export const implementReportData = {
        "statistic_root": [
            {
                "id": 1,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-01",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "root 이외에 UID/GID가 0인 사용자 존재여부",
                "important_grd": "M",
                "risk_cd": "R-LX1-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 2,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-02",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "불필요한 계정 제거",
                "important_grd": "M",
                "risk_cd": "R-LX1-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 3,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-03",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "불필요하게 쉘(shell)이 부여된 계정 존재여부",
                "important_grd": "M",
                "risk_cd": "R-LX1-03",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 4,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-04",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "패스워드 정책 설정",
                "important_grd": "M",
                "risk_cd": "R-LX1-04",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 5,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-05",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "일반 사용자의 SU 명령 제한",
                "important_grd": "M",
                "risk_cd": "R-LX1-05",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 6,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-06",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "취약한 패스워드 사용 여부",
                "important_grd": "H",
                "risk_cd": "R-LX1-06",
                "cost_measure": 5,
                "risk_measure": 5,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 39,
                "stat_eval_score": 39
            },
            {
                "id": 7,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-01",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "계정 관련 파일 접근권한 설정",
                "important_grd": "H",
                "risk_cd": "R-LX2-01",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 39,
                "stat_eval_score": 0
            },
            {
                "id": 8,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-02",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "주요 디렉터리 접근권한 설정",
                "important_grd": "H",
                "risk_cd": "R-LX2-02",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 39,
                "stat_eval_score": 39
            },
            {
                "id": 9,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-03",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "네트워크 서비스 설정 파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-03",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 10,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-04",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "원격에서 root로 로그인 가능하지 않게 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-04",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 11,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-05",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "R 서비스 설정파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-05",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 12,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-06",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "syslog.conf 파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-06",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 13,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-07",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "로그파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-07",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 14,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX3-01",
                "measure_type": "LX3\n시스템 환경설정",
                "measure_nm": "UMASK 설정",
                "important_grd": "L",
                "risk_cd": "R-LX3-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 13,
                "stat_eval_score": 0
            },
            {
                "id": 15,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX3-02",
                "measure_type": "LX3\n시스템 환경설정",
                "measure_nm": "PATH 설정",
                "important_grd": "M",
                "risk_cd": "R-LX3-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 16,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-01",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "서비스 배너에 시스템 정보 제공 여부",
                "important_grd": "L",
                "risk_cd": "R-LX4-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 13,
                "stat_eval_score": 0
            },
            {
                "id": 17,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-02",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 RPC 서비스 중지",
                "important_grd": "M",
                "risk_cd": "R-LX4-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 18,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-03",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 R 서비스(1) 구동 중지",
                "important_grd": "M",
                "risk_cd": "R-LX4-03",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 19,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-04",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 R 서비스(2) 신뢰관계설정",
                "important_grd": "M",
                "risk_cd": "R-LX4-04",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 20,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-05",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "익명 FTP(Anonymous FTP) 사용 여부",
                "important_grd": "L",
                "risk_cd": "R-LX4-05",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 13,
                "stat_eval_score": 13
            },
            {
                "id": 21,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-06",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "Telnet의 root 계정 로그인 제한",
                "important_grd": "M",
                "risk_cd": "R-LX4-06",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-10",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 22,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-07",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "SNMP - Community String 설정",
                "important_grd": "M",
                "risk_cd": "R-LX4-07",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 23,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-08",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 서비스 중지",
                "important_grd": "M",
                "risk_cd": "R-LX4-08",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 24,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX5-01",
                "measure_type": "LX5\n감사 및 로그관리",
                "measure_nm": "SU 로그 기록",
                "important_grd": "L",
                "risk_cd": "R-LX5-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-11",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 13,
                "stat_eval_score": 0
            },
            {
                "id": 25,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX5-02",
                "measure_type": "LX5\n감사 및 로그관리",
                "measure_nm": "syslog 설정",
                "important_grd": "M",
                "risk_cd": "R-LX5-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-11",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 26,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX6-01",
                "measure_type": "LX6\n패치 관리",
                "measure_nm": "최신 시스템 패치 적용",
                "important_grd": "H",
                "risk_cd": "R-LX6-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 3,
                "apply_time": "중기",
                "apply_action": "위험감소",
                "threat_cd": "TT-09",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 39,
                "stat_eval_score": 39
            }
        ],
        "statistic_measure": [
            {
                "code": "LX1",
                "name": "계정 관리",
                "total": 78,
                "Y": 39,
                "Yed": 0,
                "N": 39,
                "P": 0,
                "NA": 0,
                "total_score": 169,
                "eval_score": 91,
                "level": 53.8,
                "check": 78
            },
            {
                "code": "LX2",
                "name": "접근 통제",
                "total": 91,
                "Y": 78,
                "Yed": 0,
                "N": 13,
                "P": 0,
                "NA": 0,
                "total_score": 208,
                "eval_score": 169,
                "level": 81.2,
                "check": 91
            },
            {
                "code": "LX3",
                "name": "시스템 환경설정",
                "total": 26,
                "Y": 13,
                "Yed": 0,
                "N": 13,
                "P": 0,
                "NA": 0,
                "total_score": 39,
                "eval_score": 26,
                "level": 66.7,
                "check": 26
            },
            {
                "code": "LX4",
                "name": "네트워크 서비스",
                "total": 104,
                "Y": 78,
                "Yed": 0,
                "N": 26,
                "P": 0,
                "NA": 0,
                "total_score": 182,
                "eval_score": 143,
                "level": 78.6,
                "check": 104
            },
            {
                "code": "LX5",
                "name": "감사 및 로그관리",
                "total": 26,
                "Y": 0,
                "Yed": 0,
                "N": 26,
                "P": 0,
                "NA": 0,
                "total_score": 39,
                "eval_score": 0,
                "level": 0.0,
                "check": 26
            },
            {
                "code": "LX6",
                "name": "패치 관리",
                "total": 13,
                "Y": 13,
                "Yed": 0,
                "N": 0,
                "P": 0,
                "NA": 0,
                "total_score": 39,
                "eval_score": 39,
                "level": 100.0,
                "check": 13
            }
        ],
        "statistic_asset": [
            {
                "code": "LX01",
                "name": "ip-10-0-0-250",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX02",
                "name": "ip-10-0-10-210",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX03",
                "name": "ip-10-0-11-160",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX04",
                "name": "ip-10-0-10-69",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX05",
                "name": "ip-10-0-11-215",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX06",
                "name": "ip-10-0-10-248",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX07",
                "name": "ip-10-0-11-189",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX08",
                "name": "ip-10-0-10-193",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX09",
                "name": "ip-10-0-11-50",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX10",
                "name": "ip-10-0-10-35",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX11",
                "name": "ip-10-0-11-86",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX12",
                "name": "ip-10-0-10-11",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX13",
                "name": "ip-10-0-10-24",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            }
        ],
        "statistic_root_U": [
            {
                "id": 1,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-01",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "root 이외에 UID/GID가 0인 사용자 존재여부",
                "important_grd": "M",
                "risk_cd": "R-LX1-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 2,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-02",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "불필요한 계정 제거",
                "important_grd": "M",
                "risk_cd": "R-LX1-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 3,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-03",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "불필요하게 쉘(shell)이 부여된 계정 존재여부",
                "important_grd": "M",
                "risk_cd": "R-LX1-03",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 4,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-04",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "패스워드 정책 설정",
                "important_grd": "M",
                "risk_cd": "R-LX1-04",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 5,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-05",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "일반 사용자의 SU 명령 제한",
                "important_grd": "M",
                "risk_cd": "R-LX1-05",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 6,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX1-06",
                "measure_type": "LX1\n계정 관리",
                "measure_nm": "취약한 패스워드 사용 여부",
                "important_grd": "H",
                "risk_cd": "R-LX1-06",
                "cost_measure": 5,
                "risk_measure": 5,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-06",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 39,
                "stat_eval_score": 39
            },
            {
                "id": 7,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-01",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "계정 관련 파일 접근권한 설정",
                "important_grd": "H",
                "risk_cd": "R-LX2-01",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 39,
                "stat_eval_score": 0
            },
            {
                "id": 8,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-02",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "주요 디렉터리 접근권한 설정",
                "important_grd": "H",
                "risk_cd": "R-LX2-02",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 39,
                "stat_eval_score": 39
            },
            {
                "id": 9,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-03",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "네트워크 서비스 설정 파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-03",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 10,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-04",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "원격에서 root로 로그인 가능하지 않게 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-04",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 11,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-05",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "R 서비스 설정파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-05",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 12,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-06",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "syslog.conf 파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-06",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 13,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX2-07",
                "measure_type": "LX2\n접근 통제",
                "measure_nm": "로그파일 접근권한 설정",
                "important_grd": "M",
                "risk_cd": "R-LX2-07",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-12",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 14,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX3-01",
                "measure_type": "LX3\n시스템 환경설정",
                "measure_nm": "UMASK 설정",
                "important_grd": "L",
                "risk_cd": "R-LX3-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 13,
                "stat_eval_score": 0
            },
            {
                "id": 15,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX3-02",
                "measure_type": "LX3\n시스템 환경설정",
                "measure_nm": "PATH 설정",
                "important_grd": "M",
                "risk_cd": "R-LX3-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 16,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-01",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "서비스 배너에 시스템 정보 제공 여부",
                "important_grd": "L",
                "risk_cd": "R-LX4-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 13,
                "stat_eval_score": 0
            },
            {
                "id": 17,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-02",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 RPC 서비스 중지",
                "important_grd": "M",
                "risk_cd": "R-LX4-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 18,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-03",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 R 서비스(1) 구동 중지",
                "important_grd": "M",
                "risk_cd": "R-LX4-03",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 19,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-04",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 R 서비스(2) 신뢰관계설정",
                "important_grd": "M",
                "risk_cd": "R-LX4-04",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 20,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-05",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "익명 FTP(Anonymous FTP) 사용 여부",
                "important_grd": "L",
                "risk_cd": "R-LX4-05",
                "cost_measure": 5,
                "risk_measure": 4,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 13,
                "stat_eval_score": 13
            },
            {
                "id": 21,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-06",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "Telnet의 root 계정 로그인 제한",
                "important_grd": "M",
                "risk_cd": "R-LX4-06",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-10",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 22,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-07",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "SNMP - Community String 설정",
                "important_grd": "M",
                "risk_cd": "R-LX4-07",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-07",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 23,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX4-08",
                "measure_type": "LX4\n네트워크 서비스",
                "measure_nm": "불필요한 서비스 중지",
                "important_grd": "M",
                "risk_cd": "R-LX4-08",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-08",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 26
            },
            {
                "id": 24,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX5-01",
                "measure_type": "LX5\n감사 및 로그관리",
                "measure_nm": "SU 로그 기록",
                "important_grd": "L",
                "risk_cd": "R-LX5-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-11",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 13,
                "stat_eval_score": 0
            },
            {
                "id": 25,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX5-02",
                "measure_type": "LX5\n감사 및 로그관리",
                "measure_nm": "syslog 설정",
                "important_grd": "M",
                "risk_cd": "R-LX5-02",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 5,
                "apply_time": "단기",
                "apply_action": "위험감소",
                "threat_cd": "TT-11",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "N",
                "__LX02": "N",
                "__LX03": "N",
                "__LX04": "N",
                "__LX05": "N",
                "__LX06": "N",
                "__LX07": "N",
                "__LX08": "N",
                "__LX09": "N",
                "__LX10": "N",
                "__LX11": "N",
                "__LX12": "N",
                "__LX13": "N",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 0,
                "stat_measure_Yed": 0,
                "stat_measure_N": 13,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 26,
                "stat_eval_score": 0
            },
            {
                "id": 26,
                "report_id": "CM001_LX_2023_0001",
                "measure_cd": "LX6-01",
                "measure_type": "LX6\n패치 관리",
                "measure_nm": "최신 시스템 패치 적용",
                "important_grd": "H",
                "risk_cd": "R-LX6-01",
                "cost_measure": 5,
                "risk_measure": 3,
                "difficulty_measure": 3,
                "apply_time": "중기",
                "apply_action": "위험감소",
                "threat_cd": "TT-09",
                "sys_reg_user": null,
                "sys_reg_date": null,
                "sys_mod_user": null,
                "sys_mod_date": null,
                "__LX01": "Y",
                "__LX02": "Y",
                "__LX03": "Y",
                "__LX04": "Y",
                "__LX05": "Y",
                "__LX06": "Y",
                "__LX07": "Y",
                "__LX08": "Y",
                "__LX09": "Y",
                "__LX10": "Y",
                "__LX11": "Y",
                "__LX12": "Y",
                "__LX13": "Y",
                "stat_measure_total": 13,
                "stat_measure_check": 13,
                "stat_measure_Y": 13,
                "stat_measure_Yed": 0,
                "stat_measure_N": 0,
                "stat_measure_P": 0,
                "stat_measure_NA": 0,
                "stat_total_score": 39,
                "stat_eval_score": 39
            }
        ],
        "statistic_measure_U": [
            {
                "code": "LX1",
                "name": "계정 관리",
                "total": 78,
                "Y": 39,
                "Yed": 0,
                "N": 39,
                "P": 0,
                "NA": 0,
                "total_score": 169,
                "eval_score": 91,
                "level": 53.8,
                "check": 78
            },
            {
                "code": "LX2",
                "name": "접근 통제",
                "total": 91,
                "Y": 78,
                "Yed": 0,
                "N": 13,
                "P": 0,
                "NA": 0,
                "total_score": 208,
                "eval_score": 169,
                "level": 81.2,
                "check": 91
            },
            {
                "code": "LX3",
                "name": "시스템 환경설정",
                "total": 26,
                "Y": 13,
                "Yed": 0,
                "N": 13,
                "P": 0,
                "NA": 0,
                "total_score": 39,
                "eval_score": 26,
                "level": 66.7,
                "check": 26
            },
            {
                "code": "LX4",
                "name": "네트워크 서비스",
                "total": 104,
                "Y": 78,
                "Yed": 0,
                "N": 26,
                "P": 0,
                "NA": 0,
                "total_score": 182,
                "eval_score": 143,
                "level": 78.6,
                "check": 104
            },
            {
                "code": "LX5",
                "name": "감사 및 로그관리",
                "total": 26,
                "Y": 0,
                "Yed": 0,
                "N": 26,
                "P": 0,
                "NA": 0,
                "total_score": 39,
                "eval_score": 0,
                "level": 0.0,
                "check": 26
            },
            {
                "code": "LX6",
                "name": "패치 관리",
                "total": 13,
                "Y": 13,
                "Yed": 0,
                "N": 0,
                "P": 0,
                "NA": 0,
                "total_score": 39,
                "eval_score": 39,
                "level": 100.0,
                "check": 13
            }
        ],
        "statistic_asset_U": [
            {
                "code": "LX01",
                "name": "ip-10-0-0-250",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX02",
                "name": "ip-10-0-10-210",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX03",
                "name": "ip-10-0-11-160",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX04",
                "name": "ip-10-0-10-69",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX05",
                "name": "ip-10-0-11-215",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX06",
                "name": "ip-10-0-10-248",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX07",
                "name": "ip-10-0-11-189",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX08",
                "name": "ip-10-0-10-193",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX09",
                "name": "ip-10-0-11-50",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX10",
                "name": "ip-10-0-10-35",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX11",
                "name": "ip-10-0-11-86",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX12",
                "name": "ip-10-0-10-11",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            },
            {
                "code": "LX13",
                "name": "ip-10-0-10-24",
                "total": 26,
                "Y": 17,
                "Yed": 0,
                "N": 9,
                "P": 0,
                "NA": 0,
                "total_score": 52,
                "eval_score": 36,
                "check": 26,
                "level": 69.2
            }
        ],
        "list_measure_compare": [
            {
                "code": "LX01",
                "name": "ip-10-0-0-250",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX02",
                "name": "ip-10-0-10-210",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX03",
                "name": "ip-10-0-11-160",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX04",
                "name": "ip-10-0-10-69",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX05",
                "name": "ip-10-0-11-215",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX06",
                "name": "ip-10-0-10-248",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX07",
                "name": "ip-10-0-11-189",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX08",
                "name": "ip-10-0-10-193",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX09",
                "name": "ip-10-0-11-50",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX10",
                "name": "ip-10-0-10-35",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX11",
                "name": "ip-10-0-11-86",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX12",
                "name": "ip-10-0-10-11",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            },
            {
                "code": "LX13",
                "name": "ip-10-0-10-24",
                "total_score": 52,
                "eval_score": 36,
                "level": 69.2,
                "total_score_U": 52,
                "eval_score_U": 36,
                "level_U": 69.2,
                "improve_rate": 0.0
            }
        ]
    }